// AI-generated UI translations. Regenerate with scripts/translate_ui.py
export const UI_GENERATED = {
  "as": {
    "nav_home": "মুখ্য পৃষ্ঠা",
    "nav_services": "সেৱাসমূহ",
    "nav_knowledge": "জ্ঞান",
    "nav_concerns": "জীৱনৰ সমস্যাসমূহ",
    "nav_visit": "তাৰাপীঠ দৰ্শন",
    "nav_about": "শিৱমৰ বিষয়ে",
    "nav_contact": "যোগাযোগ",
    "cta_book": "পূজা বুক কৰক",
    "cta_speak": "শিৱম চাটাৰ্জীৰ সৈতে কথা পাতক",
    "cta_request": "মাৰ্গদৰ্শনৰ বাবে অনুৰোধ কৰক",
    "cta_discuss": "আপোনাৰ সমস্যাৰ বিষয়ে আলোচনা কৰক",
    "cta_enquire": "পূজাৰ বিষয়ে সোধা-পোচা কৰক",
    "cta_whatsapp": "WhatsApp-ত আগবাঢ়ক",
    "cta_explore": "জ্ঞানৰ কেন্দ্ৰ অন্বেষণ কৰক",
    "hero_eyebrow": "তাৰাপীঠ তন্ত্ৰৰ পৱিত্ৰ প্ৰামাণিকতা",
    "hero_title": "তাৰাপীঠৰ মা তাৰা",
    "hero_subtitle": "তাৰাপীঠ তন্ত্ৰ, মা তাৰা সাধনা, দশমহাবিদ্যা আৰু শাক্ত পৰম্পৰাৰ এক গভীৰ, নিৰ্ভৰযোগ্য স্থান — শিৱম চাটাৰ্জীৰ দ্বাৰা শ্ৰদ্ধাপূৰ্ণ আধ্যাত্মিক মাৰ্গদৰ্শন, পূজা আৰু যজ্ঞৰ সৈতে।",
    "services_eyebrow": "আপোনাৰ সমস্যা বাছক",
    "services_title": "আমি আপোনাক কেনেদৰে মাৰ্গদৰ্শন কৰিব পাৰোঁ?",
    "services_sub": "WhatsApp-ৰ জৰিয়তে সোধা-পোচা আৰম্ভ কৰিবলৈ এটা সমস্যা বা মা তাৰাৰ সেৱা বাছনি কৰক।",
    "pillars_eyebrow": "গভীৰ জ্ঞান ব্যৱস্থা",
    "pillars_title": "তাৰাপীঠ জ্ঞানৰ কেন্দ্ৰ",
    "pillars_sub": "তাৰাপীঠ আৰু তন্ত্ৰ পৰম্পৰাৰ প্ৰাৰম্ভিক পৰ্যায়ৰ পৰা উচ্চ পৰ্যায়ৰ জ্ঞান।",
    "concerns_eyebrow": "জীৱনৰ সমস্যা আৰু মাৰ্গদৰ্শন",
    "concerns_title": "জীৱনৰ প্ৰকৃত সমস্যাসমূহৰ বাবে মাৰ্গদৰ্শন",
    "read_more": "অধিক পঢ়ক",
    "learn_more": "অধিক জানক",
    "last_updated": "অন্তিমবাৰ আপডেট কৰা হৈছে",
    "beginner": "প্ৰাৰম্ভিক",
    "detailed": "বিতং",
    "advanced": "উচ্চ পৰ্যায়ৰ",
    "faq": "সঘনাই সোধা প্ৰশ্নসমূহ",
    "references": "উৎস আৰু প্ৰসংগসমূহ",
    "related": "প্ৰাসংগিক বিষয়সমূহ",
    "book_title": "আপোনাৰ সোধা-পোচা আৰম্ভ কৰক",
    "book_sub": "কিছু বিৱৰণ শ্বেয়াৰ কৰক আৰু পোনে পোনে WhatsApp-ত কথা পাতক।",
    "field_name": "আপোনাৰ নাম",
    "field_location": "স্থান (চহৰ / দেশ)",
    "field_phone": "ফোন নম্বৰ (ঐচ্ছিক)",
    "field_birth": "জন্মৰ বিৱৰণ — তাৰিখ, সময়, স্থান (ঐচ্ছিক)",
    "field_concern": "আপোনাৰ সমস্যাটো চমুকৈ বৰ্ণনা কৰক",
    "field_service": "সেৱা / সমস্যা",
    "submit_whatsapp": "প্ৰেৰণ কৰক আৰু WhatsApp খোলক",
    "submitting": "প্ৰস্তুত কৰা হৈছে...",
    "book_success": "WhatsApp খোলা হৈছে — আপোনাৰ বিৱৰণ প্ৰেৰণৰ বাবে সাজু।",
    "required": "অনুগ্ৰহ কৰি আপোনাৰ নাম লিখক।",
    "footer_tagline": "তাৰাপীঠ-ভিত্তিক আধ্যাত্মিক জ্ঞান আৰু মাৰ্গদৰ্শনৰ এক মঞ্চ।",
    "footer_explore": "অন্বেষণ কৰক",
    "footer_knowledge": "জ্ঞানৰ মূলভিত্তি",
    "footer_legal": "বিশ্বাস আৰু নীতিসমূহ",
    "footer_connect": "সংযোগ কৰক",
    "privacy": "গোপনীয়তা নীতি",
    "terms": "নিয়ম আৰু চৰ্তসমূহ",
    "disclaimer": "অস্বীকাৰ পত্ৰ",
    "editorial": "সম্পাদকীয় নীতি",
    "rights": "সৰ্বস্বত্ব সংৰক্ষিত।",
    "disclaimer_short": "আধ্যাত্মিক আৰু পৰম্পৰাগত প্ৰথাসমূহ শ্ৰদ্ধাৰে আগবঢ়োৱা হয় আৰু ই যোগ্য চিকিৎসা, মানসিক-স্বাস্থ্য, আইনী বা বিত্তীয় পৰামৰ্শৰ বিকল্প নহয়। কোনো নিৰ্দিষ্ট ফলাফলৰ নিশ্চয়তা দিয়া নহয়।",
    "nav_festivals": "উৎসৱৰ দিনপঞ্জী",
    "festivals_eyebrow": "পৱিত্ৰ চান্দ্ৰ দিনপঞ্জী",
    "festivals_title": "আগন্তুক অমাৱশ্যা আৰু উৎসৱৰ তাৰিখসমূহ",
    "festivals_sub": "চান্দ্ৰ দিনপঞ্জীৰ পৰা গণনা কৰা অমাৱশ্যা, কৌশিকী অমাৱশ্যা আৰু পূৰ্ণিমাৰ তাৰিখসমূহ। মাত্ৰ এটা টেপতে যিকোনো অনুষ্ঠানৰ বাবে পূজা সংৰক্ষণ কৰক।",
    "festival_book": "এই তাৰিখৰ বাবে সোধা-পোচা কৰক",
    "view_all_dates": "সম্পূৰ্ণ দিনপঞ্জী চাওক",
    "days_away": "দিন বাকী",
    "today": "আজি",
    "tomorrow": "কাইলৈ",
    "next_observance": "পৰৱৰ্তী অনুষ্ঠান",
    "note": "টোকা",
    "festivals_disclaimer": "ভাৰতীয় মান সময় অনুসৰি চন্দ্ৰচক্ৰৰ পৰা তাৰিখসমূহ গণনা কৰা হৈছে আৰু আপোনাৰ স্থানীয় পঞ্জিকাৰ সৈতে এদিনৰ পাৰ্থক্য থাকিব পাৰে। ভ্ৰমণ কৰাৰ আগতে অনুগ্ৰহ কৰি শিৱম চাটাৰ্জীৰ সৈতে সঠিক মুহূৰ্তটো নিশ্চিত কৰক।",
    "voices_eyebrow": "ভক্তৰ মত",
    "voices_title": "তেওঁলোকৰ ভাষাত",
    "translate_title": "আপোনাৰ ভাষা বাছনি কৰক",
    "translate_sub": "আপোনাৰ সুবিধা অনুযায়ী ভাষাত TarapithTantrik পঢ়ক।",
    "translate_search": "এটা ভাষা বিচাৰক",
    "translate_note": "বঙালী আৰু হিন্দী আমাৰ দলৰ দ্বাৰা পৰ্যালোচনা কৰা হয়। অন্যান্য ভাষাসমূহ যন্ত্ৰ-সহায়ক আৰু নিৰন্তৰ উন্নত কৰা হৈছে।",
    "no_results": "আপোনাৰ সন্ধানৰ সৈতে কোনো ভাষা মিলা নাই।",
    "ai_translated": "যন্ত্ৰ-সহায়ক অনুবাদ"
  },
  "or": {
    "nav_home": "ମୁଖ୍ୟ ପୃଷ୍ଠା",
    "nav_services": "ସେବା",
    "nav_knowledge": "ଜ୍ଞାନ",
    "nav_concerns": "ଜୀବନର ସମସ୍ୟା",
    "nav_visit": "ତାରାପୀଠ ଦର୍ଶନ",
    "nav_about": "ଶିବମ୍‌ଙ୍କ ବିଷୟରେ",
    "nav_contact": "ଯୋଗାଯୋଗ",
    "cta_book": "ପୂଜା ବୁକ୍ କରନ୍ତୁ",
    "cta_speak": "ଶିବମ୍ ଚାଟାର୍ଜୀଙ୍କ ସହ କଥା ହୁଅନ୍ତୁ",
    "cta_request": "ମାର୍ଗଦର୍ଶନ ଅନୁରୋଧ କରନ୍ତୁ",
    "cta_discuss": "ଆପଣଙ୍କ ସମସ୍ୟା ବିଷୟରେ ଆଲୋଚନା କରନ୍ତୁ",
    "cta_enquire": "ପୂଜା ବିଷୟରେ ଅନୁସନ୍ଧାନ କରନ୍ତୁ",
    "cta_whatsapp": "ହ୍ୱାଟ୍ସଆପ୍‌ରେ ଜାରି ରଖନ୍ତୁ",
    "cta_explore": "ଜ୍ଞାନ କେନ୍ଦ୍ର ବିଷୟରେ ଜାଣନ୍ତୁ",
    "hero_eyebrow": "ତାରାପୀଠ ତନ୍ତ୍ରର ପବିତ୍ର ପ୍ରାଧିକାର",
    "hero_title": "ତାରାପୀଠର ମା' ତାରା",
    "hero_subtitle": "ତାରାପୀଠ ତନ୍ତ୍ର, ମା' ତାରା ସାଧନା, ଦଶମହାବିଦ୍ୟା ଏବଂ ଶାକ୍ତ ପରମ୍ପରା ପାଇଁ ଏକ ଗଭୀର, ପ୍ରାମାଣିକ ଗନ୍ତବ୍ୟସ୍ଥଳ — ଶିବମ୍ ଚାଟାର୍ଜୀଙ୍କ ଦ୍ୱାରା ସମ୍ମାନପୂର୍ଣ୍ଣ ଆଧ୍ୟାତ୍ମିକ ମାର୍ଗଦର୍ଶନ, ପୂଜା ଏବଂ ହବନ ସହିତ।",
    "services_eyebrow": "ଆପଣଙ୍କ ସମସ୍ୟା ବାଛନ୍ତୁ",
    "services_title": "ଆମେ ଆପଣଙ୍କୁ କିପରି ମାର୍ଗଦର୍ଶନ କରିପାରିବୁ?",
    "services_sub": "ହ୍ୱାଟ୍ସଆପ୍‌ରେ ଅନୁସନ୍ଧାନ ଆରମ୍ଭ କରିବା ପାଇଁ ଏକ ସମସ୍ୟା କିମ୍ବା ମା' ତାରାଙ୍କର ଏକ ସେବା ବାଛନ୍ତୁ।",
    "pillars_eyebrow": "ଗଭୀର ଜ୍ଞାନ ବ୍ୟବସ୍ଥା",
    "pillars_title": "ତାରାପୀଠ ଜ୍ଞାନ କେନ୍ଦ୍ର",
    "pillars_sub": "ତାରାପୀଠ ଏବଂ ତନ୍ତ୍ର ପରମ୍ପରା ବିଷୟରେ ପ୍ରାରମ୍ଭିକରୁ ଉନ୍ନତ ସ୍ତରର ଜ୍ଞାନ।",
    "concerns_eyebrow": "ଜୀବନର ସମସ୍ୟା ଏବଂ ମାର୍ଗଦର୍ଶନ",
    "concerns_title": "ଜୀବନର ବାସ୍ତବ ସମସ୍ୟା ପାଇଁ ମାର୍ଗଦର୍ଶନ",
    "read_more": "ଅଧିକ ପଢ଼ନ୍ତୁ",
    "learn_more": "ଅଧିକ ଜାଣନ୍ତୁ",
    "last_updated": "ଶେଷ ଅପଡେଟ୍",
    "beginner": "ପ୍ରାରମ୍ଭିକ",
    "detailed": "ବିସ୍ତୃତ",
    "advanced": "ଉନ୍ନତ",
    "faq": "ସାଧାରଣ ପ୍ରଶ୍ନୋତ୍ତର",
    "references": "ସ୍ରୋତ ଏବଂ ସନ୍ଦର୍ଭ",
    "related": "ସମ୍ବନ୍ଧିତ ପ୍ରସଙ୍ଗ",
    "book_title": "ଆପଣଙ୍କ ଅନୁସନ୍ଧାନ ଆରମ୍ଭ କରନ୍ତୁ",
    "book_sub": "କିଛି ବିବରଣୀ ଦିଅନ୍ତୁ ଏବଂ ସିଧାସଳଖ ହ୍ୱାଟ୍ସଆପ୍‌ରେ କଥାବାର୍ତ୍ତା ଜାରି ରଖନ୍ତୁ।",
    "field_name": "ଆପଣଙ୍କ ନାମ",
    "field_location": "ସ୍ଥାନ (ସହର / ଦେଶ)",
    "field_phone": "ଫୋନ୍ ନମ୍ବର (ଇଚ୍ଛାଧୀନ)",
    "field_birth": "ଜନ୍ମ ବିବରଣୀ — ତାରିଖ, ସମୟ, ସ୍ଥାନ (ଇଚ୍ଛାଧୀନ)",
    "field_concern": "ଆପଣଙ୍କ ସମସ୍ୟା ବିଷୟରେ ସଂକ୍ଷେପରେ ଲେଖନ୍ତୁ",
    "field_service": "ସେବା / ସମସ୍ୟା",
    "submit_whatsapp": "ପଠାନ୍ତୁ ଏବଂ ହ୍ୱାଟ୍ସଆପ୍ ଖୋଲନ୍ତୁ",
    "submitting": "ପ୍ରସ୍ତୁତ କରାଯାଉଛି...",
    "book_success": "ହ୍ୱାଟ୍ସଆପ୍ ଖୋଲାଯାଉଛି — ଆପଣଙ୍କ ବିବରଣୀ ପଠାଇବା ପାଇଁ ପ୍ରସ୍ତୁତ ଅଛି।",
    "required": "ଦୟାକରି ଆପଣଙ୍କ ନାମ ଲେଖନ୍ତୁ।",
    "footer_tagline": "ତାରାପୀଠର ଏକ ପ୍ରମୁଖ ଆଧ୍ୟାତ୍ମିକ ଜ୍ଞାନ ଏବଂ ମାର୍ଗଦର୍ଶନ ପ୍ଲାଟଫର୍ମ।",
    "footer_explore": "ଅନ୍ୱେଷଣ",
    "footer_knowledge": "ଜ୍ଞାନର ସ୍ତମ୍ଭ",
    "footer_legal": "ବିଶ୍ୱାସ ଏବଂ ନୀତି",
    "footer_connect": "ଯୋଡ଼ି ହୁଅନ୍ତୁ",
    "privacy": "ଗୋପନୀୟତା ନୀତି",
    "terms": "ନିୟମ ଏବଂ ସର୍ତ୍ତାବଳୀ",
    "disclaimer": "ଅସ୍ୱୀକରଣ",
    "editorial": "ସମ୍ପାଦକୀୟ ନୀତି",
    "rights": "ସର୍ବସତ୍ତ୍ୱ ସଂରକ୍ଷିତ।",
    "disclaimer_short": "ଆଧ୍ୟାତ୍ମିକ ଏବଂ ପାରମ୍ପରିକ ପ୍ରଥାଗୁଡ଼ିକ ସମ୍ମାନର ସହ ପ୍ରଦାନ କରାଯାଏ ଏବଂ ଏହା ଯୋଗ୍ୟ ଚିକିତ୍ସା, ମାନସିକ ସ୍ୱାସ୍ଥ୍ୟ, ଆଇନଗତ କିମ୍ବା ଆର୍ଥିକ ପରାମର୍ଶର ବିକଳ୍ପ ନୁହେଁ। କୌଣସି ନିର୍ଦ୍ଦିଷ୍ଟ ଫଳାଫଳର ଗ୍ୟାରେଣ୍ଟି ଦିଆଯାଏ ନାହିଁ।",
    "nav_festivals": "ପର୍ବପର୍ବାଣୀ କ୍ୟାଲେଣ୍ଡର",
    "festivals_eyebrow": "ପବିତ୍ର ଚାନ୍ଦ୍ରମାନ ପଞ୍ଜିକା",
    "festivals_title": "ଆଗାମୀ ଅମାବାସ୍ୟା ଏବଂ ପର୍ବ ତାରିଖ",
    "festivals_sub": "ଚାନ୍ଦ୍ରମାନ ପଞ୍ଜିକାରୁ ଗଣନା କରାଯାଇଥିବା ଅମାବାସ୍ୟା, କୌଶିକୀ ଅମାବାସ୍ୟା ଏବଂ ପୂର୍ଣ୍ଣିମା ତାରିଖ। ଗୋଟିଏ କ୍ଲିକ୍‌ରେ କୌଣସି ପର୍ବ ପାଇଁ ପୂଜା ବୁକ୍ କରନ୍ତୁ।",
    "festival_book": "ଏହି ତାରିଖ ପାଇଁ ଅନୁସନ୍ଧାନ କରନ୍ତୁ",
    "view_all_dates": "ସମ୍ପୂର୍ଣ୍ଣ କ୍ୟାଲେଣ୍ଡର ଦେଖନ୍ତୁ",
    "days_away": "ଦିନ ବାକି ଅଛି",
    "today": "ଆଜି",
    "tomorrow": "ଆସନ୍ତାକାଲି",
    "next_observance": "ପରବର୍ତ୍ତୀ ପର୍ବ",
    "note": "ଧ୍ୟାନ ଦିଅନ୍ତୁ",
    "festivals_disclaimer": "ଭାରତୀୟ ମାନକ ସମୟ ଅନୁଯାୟୀ ଚନ୍ଦ୍ର ଚକ୍ରରୁ ତାରିଖଗୁଡ଼ିକ ଗଣନା କରାଯାଇଛି ଏବଂ ଏହା ଆପଣଙ୍କ ସ୍ଥାନୀୟ ପଞ୍ଜିକାଠାରୁ ଗୋଟିଏ ଦିନ ଭିନ୍ନ ହୋଇପାରେ। ଯାତ୍ରା କରିବା ପୂର୍ବରୁ ଦୟାକରି ଶିବମ୍ ଚାଟାର୍ଜୀଙ୍କ ସହିତ ସଠିକ୍ ମୁହୂର୍ତ୍ତ ନିଶ୍ଚିତ କରନ୍ତୁ।",
    "voices_eyebrow": "ଭକ୍ତମାନଙ୍କ ଅନୁଭୂତି",
    "voices_title": "ସେମାନଙ୍କ ଶବ୍ଦରେ",
    "translate_title": "ଆପଣଙ୍କ ଭାଷା ବାଛନ୍ତୁ",
    "translate_sub": "ଆପଣଙ୍କ ପସନ୍ଦର ଭାଷାରେ ତାରାପୀଠ ତାନ୍ତ୍ରିକ ପଢ଼ନ୍ତୁ।",
    "translate_search": "ଏକ ଭାଷା ଖୋଜନ୍ତୁ",
    "translate_note": "ବଙ୍ଗାଳୀ ଏବଂ ହିନ୍ଦୀ ଆମ ଟିମ୍ ଦ୍ୱାରା ଯାଞ୍ଚ କରାଯାଇଛି। ଅନ୍ୟ ଭାଷାଗୁଡ଼ିକ ମେସିନ୍ ସାହାଯ୍ୟରେ ଅନୁବାଦ କରାଯାଇଛି ଏବଂ କ୍ରମାଗତ ଭାବରେ ଉନ୍ନତ କରାଯାଉଛି।",
    "no_results": "ଆପଣଙ୍କ ସନ୍ଧାନ ସହିତ କୌଣସି ଭାଷା ମେଳ ଖାଉନାହିଁ।",
    "ai_translated": "ମେସିନ୍ ସାହାଯ୍ୟ ପ୍ରାପ୍ତ ଅନୁବାଦ"
  },
  "ne": {
    "nav_home": "मुख्य पृष्ठ",
    "nav_services": "सेवाहरू",
    "nav_knowledge": "ज्ञान",
    "nav_concerns": "जीवनका समस्याहरू",
    "nav_visit": "तारापीठ दर्शन",
    "nav_about": "शिवम् बारे",
    "nav_contact": "सम्पर्क",
    "cta_book": "पूजा बुक गर्नुहोस्",
    "cta_speak": "शिवम् च्याटर्जीसँग कुरा गर्नुहोस्",
    "cta_request": "मार्गदर्शन अनुरोध गर्नुहोस्",
    "cta_discuss": "आफ्नो समस्या छलफल गर्नुहोस्",
    "cta_enquire": "पूजाको बारेमा सोधपुछ गर्नुहोस्",
    "cta_whatsapp": "ह्वाट्सएपमा जारी राख्नुहोस्",
    "cta_explore": "ज्ञान केन्द्र अन्वेषण गर्नुहोस्",
    "hero_eyebrow": "तारापीठ तन्त्रको पवित्र आधिकारिकता",
    "hero_title": "तारापीठकी माँ तारा",
    "hero_subtitle": "तारापीठ तन्त्र, माँ तारा साधना, दशमहाविद्या र शाक्त परम्पराको गहिरो र आधिकारिक गन्तव्य — शिवम् च्याटर्जीद्वारा आदरपूर्ण आध्यात्मिक मार्गदर्शन, पूजा र हवनसहित।",
    "services_eyebrow": "आफ्नो समस्या छान्नुहोस्",
    "services_title": "हामी तपाईंलाई कसरी मार्गदर्शन गर्न सक्छौं?",
    "services_sub": "निर्देशित ह्वाट्सएप सोधपुछ सुरु गर्न कुनै समस्या वा माँ ताराको सेवा छान्नुहोस्।",
    "pillars_eyebrow": "गहिरो ज्ञान प्रणाली",
    "pillars_title": "तारापीठ ज्ञान केन्द्र",
    "pillars_sub": "तारापीठ र तन्त्र परम्पराको प्रारम्भिकदेखि विस्तृत र गहिरो बुझाइ।",
    "concerns_eyebrow": "जीवनका समस्याहरू र मार्गदर्शन",
    "concerns_title": "जीवनका वास्तविक समस्याहरूको लागि मार्गदर्शन",
    "read_more": "थप पढ्नुहोस्",
    "learn_more": "थप जान्नुहोस्",
    "last_updated": "पछिल्लो अद्यावधिक",
    "beginner": "प्रारम्भिक",
    "detailed": "विस्तृत",
    "advanced": "उन्नत",
    "faq": "धेरै सोधिने प्रश्नहरू",
    "references": "स्रोत र सन्दर्भहरू",
    "related": "सम्बन्धित विषयहरू",
    "book_title": "आफ्नो निर्देशित सोधपुछ सुरु गर्नुहोस्",
    "book_sub": "केही विवरणहरू साझा गर्नुहोस् र सिधै ह्वाट्सएपमा कुराकानीलाई अगाडि बढाउनुहोस्।",
    "field_name": "तपाईंको नाम",
    "field_location": "स्थान (शहर / देश)",
    "field_phone": "फोन (वैकल्पिक)",
    "field_birth": "जन्म विवरण — मिति, समय, स्थान (वैकल्पिक)",
    "field_concern": "आफ्नो समस्या छोटकरीमा वर्णन गर्नुहोस्",
    "field_service": "सेवा / समस्या",
    "submit_whatsapp": "पठाउनुहोस् र ह्वाट्सएप खोल्नुहोस्",
    "submitting": "तयार गर्दै...",
    "book_success": "ह्वाट्सएप खुल्दैछ — तपाईंका विवरणहरू पठाउन तयार छन्।",
    "required": "कृपया आफ्नो नाम लेख्नुहोस्।",
    "footer_tagline": "तारापीठलाई प्राथमिकता दिने एक आध्यात्मिक ज्ञान र मार्गदर्शन मञ्च।",
    "footer_explore": "अन्वेषण गर्नुहोस्",
    "footer_knowledge": "ज्ञानका स्तम्भहरू",
    "footer_legal": "विश्वास र नीतिहरू",
    "footer_connect": "जोडिनुहोस्",
    "privacy": "गोपनीयता नीति",
    "terms": "नियम र सर्तहरू",
    "disclaimer": "अस्वीकरण",
    "editorial": "सम्पादकीय नीति",
    "rights": "सर्वाधिकार सुरक्षित।",
    "disclaimer_short": "आध्यात्मिक र परम्परागत अभ्यासहरूलाई सम्मानपूर्वक प्रदान गरिन्छ र यसले योग्य चिकित्सा, मानसिक स्वास्थ्य, कानुनी वा वित्तीय सल्लाहलाई प्रतिस्थापन गर्दैन। कुनै निश्चित परिणामको ग्यारेन्टी दिइँदैन।",
    "nav_festivals": "चाडपर्व क्यालेन्डर",
    "festivals_eyebrow": "पवित्र पञ्चाङ्ग",
    "festivals_title": "आगामी अमावस्या र चाडपर्वका मितिहरू",
    "festivals_sub": "चन्द्र क्यालेन्डरबाट गणना गरिएका अमावस्या, कौशिकी अमावस्या र पूर्णिमाका मितिहरू। कुनै पनि अवसरका लागि एकै ट्यापमा पूजा बुक गर्नुहोस्।",
    "festival_book": "यस मितिका लागि सोधपुछ गर्नुहोस्",
    "view_all_dates": "पूरा क्यालेन्डर हेर्नुहोस्",
    "days_away": "दिन बाँकी",
    "today": "आज",
    "tomorrow": "भोलि",
    "next_observance": "आगामी पर्व",
    "note": "नोट",
    "festivals_disclaimer": "मितिहरू भारतीय मानक समयको चन्द्र चक्रबाट गणना गरिएका हुन् र तपाईंको स्थानीय पञ्चाङ्गभन्दा एक दिन फरक हुन सक्छन्। यात्रा गर्नुअघि कृपया शिवम् च्याटर्जीसँग सटीक मुहूर्त पुष्टि गर्नुहोस्।",
    "voices_eyebrow": "भक्तका अनुभवहरू",
    "voices_title": "उनीहरूकै शब्दहरूमा",
    "translate_title": "आफ्नो भाषा छान्नुहोस्",
    "translate_sub": "तारापीठतान्त्रिक (TarapithTantrik) लाई आफूलाई सहज लाग्ने भाषामा पढ्नुहोस्।",
    "translate_search": "भाषा खोज्नुहोस्",
    "translate_note": "बंगाली र हिन्दी हाम्रो टोलीद्वारा समीक्षा गरिएका छन्। अन्य भाषाहरू मेसिन-सहायता प्राप्त हुन् र निरन्तर सुधार भइरहेका छन्।",
    "no_results": "तपाईंको खोजीसँग कुनै भाषा मेल खाएन।",
    "ai_translated": "मेसिन-सहायता प्राप्त अनुवाद"
  },
  "mr": {
    "nav_home": "मुख्य पृष्ठ",
    "nav_services": "सेवा",
    "nav_knowledge": "ज्ञान",
    "nav_concerns": "जीवनातील समस्या",
    "nav_visit": "तारापीठ दर्शन",
    "nav_about": "शिवम बद्दल",
    "nav_contact": "संपर्क",
    "cta_book": "पूजा बुक करा",
    "cta_speak": "शिवम चॅटर्जी यांच्याशी बोला",
    "cta_request": "मार्गदर्शनाची विनंती करा",
    "cta_discuss": "तुमच्या समस्येवर चर्चा करा",
    "cta_enquire": "पूजेबद्दल चौकशी करा",
    "cta_whatsapp": "व्हॉट्सॲपवर सुरू ठेवा",
    "cta_explore": "ज्ञान केंद्र एक्सप्लोर करा",
    "hero_eyebrow": "तारापीठ तंत्राचे पवित्र अधिकार",
    "hero_title": "तारापीठाची माँ तारा",
    "hero_subtitle": "तारापीठ तंत्र, माँ तारा साधना, दशमहाविद्या आणि शाक्त परंपरेसाठी एक सखोल आणि अधिकृत स्थान — शिवम चॅटर्जी यांच्याकडून आदरपूर्ण आध्यात्मिक मार्गदर्शन, पूजा आणि हवन.",
    "services_eyebrow": "तुमची समस्या निवडा",
    "services_title": "आम्ही तुम्हाला कसे मार्गदर्शन करू शकतो?",
    "services_sub": "मार्गदर्शित व्हॉट्सॲप चौकशी सुरू करण्यासाठी एखादी समस्या किंवा माँ तारा सेवा निवडा.",
    "pillars_eyebrow": "सखोल ज्ञान प्रणाली",
    "pillars_title": "तारापीठ ज्ञान केंद्र",
    "pillars_sub": "तारापीठ आणि तंत्राच्या परंपरांबद्दल प्राथमिक ते प्रगत स्तरापर्यंतचे ज्ञान.",
    "concerns_eyebrow": "जीवनातील समस्या आणि मार्गदर्शन",
    "concerns_title": "जीवनातील वास्तविक समस्यांसाठी मार्गदर्शन",
    "read_more": "अधिक वाचा",
    "learn_more": "अधिक जाणून घ्या",
    "last_updated": "शेवटचे अपडेट",
    "beginner": "प्राथमिक",
    "detailed": "सविस्तर",
    "advanced": "प्रगत",
    "faq": "नेहमी विचारले जाणारे प्रश्न",
    "references": "स्रोत आणि संदर्भ",
    "related": "संबंधित विषय",
    "book_title": "तुमची मार्गदर्शित चौकशी सुरू करा",
    "book_sub": "काही माहिती सामायिक करा आणि व्हॉट्सॲपवर थेट संवाद सुरू ठेवा.",
    "field_name": "तुमचे नाव",
    "field_location": "स्थान (शहर / देश)",
    "field_phone": "फोन (पर्यायी)",
    "field_birth": "जन्माचा तपशील — तारीख, वेळ, ठिकाण (पर्यायी)",
    "field_concern": "तुमच्या समस्येचे थोडक्यात वर्णन करा",
    "field_service": "सेवा / समस्या",
    "submit_whatsapp": "पाठवा आणि व्हॉट्सॲप उघडा",
    "submitting": "तयार करत आहे...",
    "book_success": "व्हॉट्सॲप उघडत आहे — तुमचा तपशील पाठवण्यासाठी तयार आहे.",
    "required": "कृपया तुमचे नाव प्रविष्ट करा.",
    "footer_tagline": "तारापीठाला प्राधान्य देणारे आध्यात्मिक ज्ञान आणि मार्गदर्शन व्यासपीठ.",
    "footer_explore": "एक्सप्लोर करा",
    "footer_knowledge": "ज्ञानाचे स्तंभ",
    "footer_legal": "विश्वास आणि धोरणे",
    "footer_connect": "संपर्क साधा",
    "privacy": "गोपनीयता धोरण",
    "terms": "अटी आणि शर्ती",
    "disclaimer": "अस्वीकरण",
    "editorial": "संपादकीय धोरण",
    "rights": "सर्व हक्क राखीव.",
    "disclaimer_short": "आध्यात्मिक आणि पारंपारिक प्रथा आदरपूर्वक दिल्या जातात आणि त्या पात्र वैद्यकीय, मानसिक-आरोग्य, कायदेशीर किंवा आर्थिक सल्ल्याची जागा घेत नाहीत. कोणत्याही विशिष्ट परिणामाची हमी दिली जात नाही.",
    "nav_festivals": "उत्सव दिनदर्शिका",
    "festivals_eyebrow": "पवित्र चंद्र दिनदर्शिका",
    "festivals_title": "आगामी अमावस्या आणि उत्सवांच्या तारखा",
    "festivals_sub": "चंद्र दिनदर्शिकेनुसार मोजलेल्या अमावस्या, कौशिकी अमावस्या आणि पौर्णिमेच्या तारखा. कोणत्याही उत्सवासाठी एका क्लिकवर पूजा बुक करा.",
    "festival_book": "या तारखेसाठी चौकशी करा",
    "view_all_dates": "संपूर्ण दिनदर्शिका पहा",
    "days_away": "दिवस शिल्लक",
    "today": "आज",
    "tomorrow": "उद्या",
    "next_observance": "पुढील उत्सव",
    "note": "नोंद",
    "festivals_disclaimer": "भारतीय प्रमाण वेळेनुसार चंद्र चक्रावरून तारखा मोजल्या जातात आणि तुमच्या स्थानिक पंचांगानुसार त्यात एका दिवसाचा फरक असू शकतो. कृपया प्रवास करण्यापूर्वी शिवम चॅटर्जी यांच्याशी अचूक मुहूर्ताची पुष्टी करा.",
    "voices_eyebrow": "भक्तांचे मनोगत",
    "voices_title": "त्यांच्या शब्दांत",
    "translate_title": "तुमची भाषा निवडा",
    "translate_sub": "तुम्हाला सोयीच्या वाटणाऱ्या भाषेत तारापीठ तांत्रिक वाचा.",
    "translate_search": "भाषा शोधा",
    "translate_note": "बंगाली आणि हिंदी भाषेचे आमच्या टीमकडून पुनरावलोकन केले जाते. इतर भाषा मशीन-सहाय्यित आहेत आणि त्यामध्ये सतत सुधारणा केली जात आहे.",
    "no_results": "तुमच्या शोधाशी जुळणारी कोणतीही भाषा नाही.",
    "ai_translated": "मशीन-सहाय्यित भाषांतर"
  },
  "gu": {
    "nav_home": "હોમ",
    "nav_services": "સેવાઓ",
    "nav_knowledge": "જ્ઞાન",
    "nav_concerns": "જીવનની સમસ્યાઓ",
    "nav_visit": "તારાપીઠની મુલાકાત",
    "nav_about": "શિવમ વિશે",
    "nav_contact": "સંપર્ક",
    "cta_book": "પૂજા બુક કરો",
    "cta_speak": "શિવમ ચેટરજી સાથે વાત કરો",
    "cta_request": "માર્ગદર્શનની વિનંતી કરો",
    "cta_discuss": "તમારી સમસ્યાની ચર્ચા કરો",
    "cta_enquire": "પૂજા અંગે પૂછપરછ કરો",
    "cta_whatsapp": "વ્હોટ્સએપ પર આગળ વધો",
    "cta_explore": "જ્ઞાન કેન્દ્રનું અન્વેષણ કરો",
    "hero_eyebrow": "તારાપીઠ તંત્રની પવિત્ર સત્તા",
    "hero_title": "તારાપીઠનાં મા તારા",
    "hero_subtitle": "તારાપીઠ તંત્ર, મા તારા સાધના, દશમહાવિદ્યા અને શાક્ત પરંપરા માટે એક ગહન, અધિકૃત સ્થાન — શિવમ ચેટરજી દ્વારા આદરણીય આધ્યાત્મિક માર્ગદર્શન, પૂજા અને હવન સાથે.",
    "services_eyebrow": "તમારી સમસ્યા પસંદ કરો",
    "services_title": "અમે તમને કેવી રીતે માર્ગદર્શન આપી શકીએ?",
    "services_sub": "વ્હોટ્સએપ પૂછપરછ શરૂ કરવા માટે કોઈ સમસ્યા અથવા મા તારાની સેવા પસંદ કરો.",
    "pillars_eyebrow": "ગહન જ્ઞાનની ઇકોસિસ્ટમ",
    "pillars_title": "તારાપીઠ જ્ઞાન કેન્દ્ર",
    "pillars_sub": "તારાપીઠ અને તંત્રની પરંપરાઓની પ્રારંભિકથી લઈને અદ્યતન સમજ.",
    "concerns_eyebrow": "જીવનની સમસ્યાઓ અને માર્ગદર્શન",
    "concerns_title": "જીવનની વાસ્તવિક સમસ્યાઓ માટે માર્ગદર્શન",
    "read_more": "વધુ વાંચો",
    "learn_more": "વધુ જાણો",
    "last_updated": "છેલ્લે અપડેટ કર્યું",
    "beginner": "પ્રારંભિક",
    "detailed": "વિસ્તૃત",
    "advanced": "અદ્યતન",
    "faq": "વારંવાર પૂછાતા પ્રશ્નો",
    "references": "સ્ત્રોતો અને સંદર્ભો",
    "related": "સંબંધિત વિષયો",
    "book_title": "તમારી માર્ગદર્શિત પૂછપરછ શરૂ કરો",
    "book_sub": "થોડી વિગતો શેર કરો અને સીધી વ્હોટ્સએપ પર વાતચીત ચાલુ રાખો.",
    "field_name": "તમારું નામ",
    "field_location": "સ્થળ (શહેર / દેશ)",
    "field_phone": "ફોન (વૈકલ્પિક)",
    "field_birth": "જન્મની વિગતો — તારીખ, સમય, સ્થળ (વૈકલ્પિક)",
    "field_concern": "તમારી સમસ્યાનું ટૂંકમાં વર્ણન કરો",
    "field_service": "સેવા / સમસ્યા",
    "submit_whatsapp": "મોકલો અને વ્હોટ્સએપ ખોલો",
    "submitting": "તૈયાર થઈ રહ્યું છે...",
    "book_success": "વ્હોટ્સએપ ખુલી રહ્યું છે — તમારી વિગતો મોકલવા માટે તૈયાર છે.",
    "required": "કૃપા કરીને તમારું નામ દાખલ કરો.",
    "footer_tagline": "તારાપીઠ-પ્રથમ આધ્યાત્મિક જ્ઞાન અને માર્ગદર્શન પ્લેટફોર્મ.",
    "footer_explore": "અન્વેષણ કરો",
    "footer_knowledge": "જ્ઞાન સ્તંભો",
    "footer_legal": "વિશ્વાસ અને નીતિઓ",
    "footer_connect": "જોડાવો",
    "privacy": "ગોપનીયતા નીતિ",
    "terms": "નિયમો અને શરતો",
    "disclaimer": "અસ્વીકરણ",
    "editorial": "સંપાદકીય નીતિ",
    "rights": "બધા હકો આરક્ષિત છે.",
    "disclaimer_short": "આધ્યાત્મિક અને પરંપરાગત પ્રથાઓ આદરપૂર્વક ઓફર કરવામાં આવે છે અને તે યોગ્ય તબીબી, માનસિક-સ્વાસ્થ્ય, કાનૂની અથવા નાણાકીય સલાહનું સ્થાન લેતી નથી. કોઈ ચોક્કસ પરિણામની ખાતરી આપવામાં આવતી નથી.",
    "nav_festivals": "ઉત્સવ કેલેન્ડર",
    "festivals_eyebrow": "પવિત્ર ચાંદ્ર પંચાંગ",
    "festivals_title": "આગામી અમાવસ્યા અને ઉત્સવની તારીખો",
    "festivals_sub": "અમાવસ્યા, કૌશિકી અમાવસ્યા અને પૂર્ણિમાની તારીખો ચાંદ્ર પંચાંગ પરથી ગણવામાં આવે છે. કોઈપણ પર્વ માટે એક ટેપમાં પૂજા બુક કરો.",
    "festival_book": "આ તારીખ માટે પૂછપરછ કરો",
    "view_all_dates": "સંપૂર્ણ કેલેન્ડર જુઓ",
    "days_away": "દિવસ બાકી છે",
    "today": "આજે",
    "tomorrow": "આવતીકાલે",
    "next_observance": "આગામી પર્વ",
    "note": "નોંધ",
    "festivals_disclaimer": "તારીખો ભારતીય પ્રમાણભૂત સમય મુજબ ચંદ્ર ચક્ર પરથી ગણવામાં આવે છે અને તમારા સ્થાનિક પંચાંગથી એક દિવસનો તફાવત હોઈ શકે છે. કૃપા કરીને મુસાફરી કરતા પહેલા શિવમ ચેટરજી સાથે ચોક્કસ મુહૂર્તની પુષ્ટિ કરો.",
    "voices_eyebrow": "ભક્તોનો અવાજ",
    "voices_title": "તેમના શબ્દોમાં",
    "translate_title": "તમારી ભાષા પસંદ કરો",
    "translate_sub": "તમને સૌથી વધુ અનુકૂળ હોય તેવી ભાષામાં TarapithTantrik વાંચો.",
    "translate_search": "ભાષા શોધો",
    "translate_note": "બંગાળી અને હિન્દીની સમીક્ષા અમારી ટીમ દ્વારા કરવામાં આવે છે. અન્ય ભાષાઓ મશીન-સહાયિત છે અને તેમાં સતત સુધારો થઈ રહ્યો છે.",
    "no_results": "તમારી શોધ સાથે કોઈ ભાષા મેળ ખાતી નથી.",
    "ai_translated": "મશીન-સહાયિત અનુવાદ"
  },
  "pa": {
    "nav_home": "ਮੁੱਖ ਪੰਨਾ",
    "nav_services": "ਸੇਵਾਵਾਂ",
    "nav_knowledge": "ਗਿਆਨ",
    "nav_concerns": "ਜੀਵਨ ਦੀਆਂ ਸਮੱਸਿਆਵਾਂ",
    "nav_visit": "ਤਾਰਾਪੀਠ ਯਾਤਰਾ",
    "nav_about": "ਸ਼ਿਵਮ ਬਾਰੇ",
    "nav_contact": "ਸੰਪਰਕ",
    "cta_book": "ਪੂਜਾ ਬੁੱਕ ਕਰੋ",
    "cta_speak": "ਸ਼ਿਵਮ ਚੈਟਰਜੀ ਨਾਲ ਗੱਲ ਕਰੋ",
    "cta_request": "ਮਾਰਗਦਰਸ਼ਨ ਲਈ ਬੇਨਤੀ ਕਰੋ",
    "cta_discuss": "ਆਪਣੀ ਸਮੱਸਿਆ ਬਾਰੇ ਚਰਚਾ ਕਰੋ",
    "cta_enquire": "ਪੂਜਾ ਬਾਰੇ ਪੁੱਛਗਿੱਛ ਕਰੋ",
    "cta_whatsapp": "ਵਟਸਐਪ 'ਤੇ ਜਾਰੀ ਰੱਖੋ",
    "cta_explore": "ਗਿਆਨ ਕੇਂਦਰ ਦੀ ਪੜਚੋਲ ਕਰੋ",
    "hero_eyebrow": "ਤਾਰਾਪੀਠ ਤੰਤਰ ਦੀ ਪਵਿੱਤਰ ਪ੍ਰਮਾਣਿਕਤਾ",
    "hero_title": "ਤਾਰਾਪੀਠ ਦੀ ਮਾਂ ਤਾਰਾ",
    "hero_subtitle": "ਤਾਰਾਪੀਠ ਤੰਤਰ, ਮਾਂ ਤਾਰਾ ਸਾਧਨਾ, ਦਸ਼ਮਹਾਵਿੱਦਿਆ ਅਤੇ ਸ਼ਾਕਤ ਪਰੰਪਰਾ ਲਈ ਇੱਕ ਡੂੰਘਾ ਅਤੇ ਪ੍ਰਮਾਣਿਕ ਸਥਾਨ — ਜਿੱਥੇ ਸ਼ਿਵਮ ਚੈਟਰਜੀ ਦੁਆਰਾ ਸਤਿਕਾਰਤ ਅਧਿਆਤਮਿਕ ਮਾਰਗਦਰਸ਼ਨ, ਪੂਜਾ ਅਤੇ ਹਵਨ ਪ੍ਰਦਾਨ ਕੀਤੇ ਜਾਂਦੇ ਹਨ।",
    "services_eyebrow": "ਆਪਣੀ ਸਮੱਸਿਆ ਚੁਣੋ",
    "services_title": "ਅਸੀਂ ਤੁਹਾਡਾ ਮਾਰਗਦਰਸ਼ਨ ਕਿਵੇਂ ਕਰ ਸਕਦੇ ਹਾਂ?",
    "services_sub": "ਵਟਸਐਪ 'ਤੇ ਪੁੱਛਗਿੱਛ ਸ਼ੁਰੂ ਕਰਨ ਲਈ ਕੋਈ ਸਮੱਸਿਆ ਜਾਂ ਮਾਂ ਤਾਰਾ ਦੀ ਸੇਵਾ ਚੁਣੋ।",
    "pillars_eyebrow": "ਡੂੰਘੀ ਗਿਆਨ ਪ੍ਰਣਾਲੀ",
    "pillars_title": "ਤਾਰਾਪੀਠ ਗਿਆਨ ਕੇਂਦਰ",
    "pillars_sub": "ਤਾਰਾਪੀਠ ਅਤੇ ਤੰਤਰ ਦੀਆਂ ਪਰੰਪਰਾਵਾਂ ਬਾਰੇ ਸ਼ੁਰੂਆਤੀ ਤੋਂ ਲੈ ਕੇ ਉੱਨਤ ਪੱਧਰ ਤੱਕ ਦੀ ਸਮਝ।",
    "concerns_eyebrow": "ਜੀਵਨ ਦੀਆਂ ਸਮੱਸਿਆਵਾਂ ਅਤੇ ਮਾਰਗਦਰਸ਼ਨ",
    "concerns_title": "ਜੀਵਨ ਦੀਆਂ ਅਸਲ ਸਮੱਸਿਆਵਾਂ ਲਈ ਮਾਰਗਦਰਸ਼ਨ",
    "read_more": "ਹੋਰ ਪੜ੍ਹੋ",
    "learn_more": "ਹੋਰ ਜਾਣੋ",
    "last_updated": "ਆਖਰੀ ਅੱਪਡੇਟ",
    "beginner": "ਸ਼ੁਰੂਆਤੀ",
    "detailed": "ਵਿਸਤ੍ਰਿਤ",
    "advanced": "ਉੱਨਤ",
    "faq": "ਅਕਸਰ ਪੁੱਛੇ ਜਾਣ ਵਾਲੇ ਸਵਾਲ",
    "references": "ਸਰੋਤ ਅਤੇ ਹਵਾਲੇ",
    "related": "ਸੰਬੰਧਿਤ ਵਿਸ਼ੇ",
    "book_title": "ਆਪਣੀ ਪੁੱਛਗਿੱਛ ਸ਼ੁਰੂ ਕਰੋ",
    "book_sub": "ਕੁਝ ਵੇਰਵੇ ਸਾਂਝੇ ਕਰੋ ਅਤੇ ਸਿੱਧੇ ਵਟਸਐਪ 'ਤੇ ਗੱਲਬਾਤ ਜਾਰੀ ਰੱਖੋ।",
    "field_name": "ਤੁਹਾਡਾ ਨਾਮ",
    "field_location": "ਸਥਾਨ (ਸ਼ਹਿਰ / ਦੇਸ਼)",
    "field_phone": "ਫੋਨ ਨੰਬਰ (ਵਿਕਲਪਿਕ)",
    "field_birth": "ਜਨਮ ਦੇ ਵੇਰਵੇ — ਮਿਤੀ, ਸਮਾਂ, ਸਥਾਨ (ਵਿਕਲਪਿਕ)",
    "field_concern": "ਆਪਣੀ ਸਮੱਸਿਆ ਦਾ ਸੰਖੇਪ ਵਿੱਚ ਵਰਣਨ ਕਰੋ",
    "field_service": "ਸੇਵਾ / ਸਮੱਸਿਆ",
    "submit_whatsapp": "ਭੇਜੋ ਅਤੇ ਵਟਸਐਪ ਖੋਲ੍ਹੋ",
    "submitting": "ਤਿਆਰ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
    "book_success": "ਵਟਸਐਪ ਖੁੱਲ੍ਹ ਰਿਹਾ ਹੈ — ਤੁਹਾਡੇ ਵੇਰਵੇ ਭੇਜਣ ਲਈ ਤਿਆਰ ਹਨ।",
    "required": "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਨਾਮ ਦਰਜ ਕਰੋ।",
    "footer_tagline": "ਤਾਰਾਪੀਠ ਨੂੰ ਸਮਰਪਿਤ ਇੱਕ ਅਧਿਆਤਮਿਕ ਗਿਆਨ ਅਤੇ ਮਾਰਗਦਰਸ਼ਨ ਪਲੇਟਫਾਰਮ।",
    "footer_explore": "ਪੜਚੋਲ ਕਰੋ",
    "footer_knowledge": "ਗਿਆਨ ਦੇ ਥੰਮ੍ਹ",
    "footer_legal": "ਭਰੋਸਾ ਅਤੇ ਨੀਤੀਆਂ",
    "footer_connect": "ਸੰਪਰਕ ਕਰੋ",
    "privacy": "ਪਰਦੇਦਾਰੀ ਨੀਤੀ",
    "terms": "ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ",
    "disclaimer": "ਬੇਦਾਅਵਾ",
    "editorial": "ਸੰਪਾਦਕੀ ਨੀਤੀ",
    "rights": "ਸਾਰੇ ਹੱਕ ਰਾਖਵੇਂ ਹਨ।",
    "disclaimer_short": "ਅਧਿਆਤਮਿਕ ਅਤੇ ਰਵਾਇਤੀ ਅਭਿਆਸ ਸਤਿਕਾਰ ਸਹਿਤ ਪੇਸ਼ ਕੀਤੇ ਜਾਂਦੇ ਹਨ ਅਤੇ ਇਹ ਯੋਗਤਾ ਪ੍ਰਾਪਤ ਡਾਕਟਰੀ, ਮਾਨਸਿਕ-ਸਿਹਤ, ਕਾਨੂੰਨੀ ਜਾਂ ਵਿੱਤੀ ਸਲਾਹ ਦੀ ਥਾਂ ਨਹੀਂ ਲੈਂਦੇ। ਕਿਸੇ ਵਿਸ਼ੇਸ਼ ਨਤੀਜੇ ਦੀ ਗਰੰਟੀ ਨਹੀਂ ਹੈ।",
    "nav_festivals": "ਤਿਉਹਾਰ ਕੈਲੰਡਰ",
    "festivals_eyebrow": "ਪਵਿੱਤਰ ਚੰਦਰ ਕੈਲੰਡਰ",
    "festivals_title": "ਆਉਣ ਵਾਲੀਆਂ ਅਮਾਵਸਿਆ ਅਤੇ ਤਿਉਹਾਰ ਦੀਆਂ ਤਾਰੀਖਾਂ",
    "festivals_sub": "ਅਮਾਵਸਿਆ, ਕੌਸ਼ਿਕੀ ਅਮਾਵਸਿਆ ਅਤੇ ਪੂਰਨਿਮਾ ਦੀਆਂ ਤਾਰੀਖਾਂ ਚੰਦਰ ਕੈਲੰਡਰ ਤੋਂ ਗਿਣੀਆਂ ਗਈਆਂ ਹਨ। ਕਿਸੇ ਵੀ ਪਵਿੱਤਰ ਦਿਹਾੜੇ ਲਈ ਇੱਕ ਕਲਿੱਕ ਨਾਲ ਪੂਜਾ ਬੁੱਕ ਕਰੋ।",
    "festival_book": "ਇਸ ਤਾਰੀਖ ਲਈ ਪੁੱਛਗਿੱਛ ਕਰੋ",
    "view_all_dates": "ਪੂਰਾ ਕੈਲੰਡਰ ਦੇਖੋ",
    "days_away": "ਦਿਨ ਬਾਕੀ",
    "today": "ਅੱਜ",
    "tomorrow": "ਕੱਲ੍ਹ",
    "next_observance": "ਅਗਲਾ ਪਵਿੱਤਰ ਦਿਹਾੜਾ",
    "note": "ਨੋਟ",
    "festivals_disclaimer": "ਤਾਰੀਖਾਂ ਭਾਰਤੀ ਮਿਆਰੀ ਸਮੇਂ ਅਨੁਸਾਰ ਚੰਦਰ ਚੱਕਰ ਤੋਂ ਗਿਣੀਆਂ ਗਈਆਂ ਹਨ ਅਤੇ ਤੁਹਾਡੇ ਸਥਾਨਕ ਪੰਚਾਂਗ ਤੋਂ ਇੱਕ ਦਿਨ ਵੱਖਰੀਆਂ ਹੋ ਸਕਦੀਆਂ ਹਨ। ਕਿਰਪਾ ਕਰਕੇ ਯਾਤਰਾ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਸ਼ਿਵਮ ਚੈਟਰਜੀ ਨਾਲ ਸਹੀ ਮੁਹੂਰਤ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ।",
    "voices_eyebrow": "ਸ਼ਰਧਾਲੂਆਂ ਦੇ ਵਿਚਾਰ",
    "voices_title": "ਉਨ੍ਹਾਂ ਦੇ ਸ਼ਬਦਾਂ ਵਿੱਚ",
    "translate_title": "ਆਪਣੀ ਭਾਸ਼ਾ ਚੁਣੋ",
    "translate_sub": "ਉਸ ਭਾਸ਼ਾ ਵਿੱਚ TarapithTantrik ਪੜ੍ਹੋ ਜਿਸ ਵਿੱਚ ਤੁਸੀਂ ਸਭ ਤੋਂ ਵੱਧ ਸਹਿਜ ਹੋ।",
    "translate_search": "ਕੋਈ ਭਾਸ਼ਾ ਖੋਜੋ",
    "translate_note": "ਬੰਗਾਲੀ ਅਤੇ ਹਿੰਦੀ ਦੀ ਸਾਡੀ ਟੀਮ ਦੁਆਰਾ ਸਮੀਖਿਆ ਕੀਤੀ ਜਾਂਦੀ ਹੈ। ਹੋਰ ਭਾਸ਼ਾਵਾਂ ਮਸ਼ੀਨ ਦੁਆਰਾ ਅਨੁਵਾਦਿਤ ਹਨ ਅਤੇ ਲਗਾਤਾਰ ਸੁਧਾਰੀਆਂ ਜਾ ਰਹੀਆਂ ਹਨ।",
    "no_results": "ਤੁਹਾਡੀ ਖੋਜ ਨਾਲ ਕੋਈ ਭਾਸ਼ਾ ਮੇਲ ਨਹੀਂ ਖਾਂਦੀ।",
    "ai_translated": "ਮਸ਼ੀਨ ਦੁਆਰਾ ਅਨੁਵਾਦ"
  },
  "ta": {
    "nav_home": "முகப்பு",
    "nav_services": "சேவைகள்",
    "nav_knowledge": "அறிவுத் தளம்",
    "nav_concerns": "வாழ்க்கைப் பிரச்சனைகள்",
    "nav_visit": "தாராபீத் தரிசனம்",
    "nav_about": "சிவம் பற்றி",
    "nav_contact": "தொடர்புக்கு",
    "cta_book": "பூஜைக்கு முன்பதிவு செய்க",
    "cta_speak": "சிவம் சாட்டர்ஜியுடன் பேசுங்கள்",
    "cta_request": "வழிகாட்டுதல் பெறுக",
    "cta_discuss": "உங்கள் பிரச்சனையை விவாதிக்க",
    "cta_enquire": "பூஜை பற்றி விசாரிக்க",
    "cta_whatsapp": "வாட்ஸ்அப்பில் தொடரவும்",
    "cta_explore": "அறிவுத் தளத்தை ஆராய்க",
    "hero_eyebrow": "தாராபீத் தாந்த்ரீகத்தின் புனிதமான வழிகாட்டுதல்",
    "hero_title": "தாராபீத் மா தாரா",
    "hero_subtitle": "தாராபீத் தாந்த்ரீகம், மா தாரா சாதனா, தசமஹாவித்யா மற்றும் சாக்த மரபிற்கான ஆழமான தளம் — சிவம் சாட்டர்ஜியின் மரியாதைக்குரிய ஆன்மீக வழிகாட்டுதல், பூஜை மற்றும் ஹோமத்துடன்.",
    "services_eyebrow": "உங்கள் பிரச்சனையை தேர்ந்தெடுக்கவும்",
    "services_title": "நாங்கள் உங்களுக்கு எப்படி உதவ முடியும்?",
    "services_sub": "வாட்ஸ்அப் மூலம் விசாரணையைத் தொடங்க, ஒரு பிரச்சனை அல்லது மா தாரா சேவையைத் தேர்ந்தெடுக்கவும்.",
    "pillars_eyebrow": "ஆழமான அறிவுத் தளம்",
    "pillars_title": "தாராபீத் அறிவுக்களஞ்சியம்",
    "pillars_sub": "தாராபீத் மற்றும் தாந்த்ரீக மரபுகள் குறித்த அடிப்படை முதல் மேம்பட்ட புரிதல் வரை.",
    "concerns_eyebrow": "வாழ்க்கைப் பிரச்சனைகளும் வழிகாட்டுதலும்",
    "concerns_title": "வாழ்க்கையின் உண்மையான பிரச்சனைகளுக்கான வழிகாட்டுதல்",
    "read_more": "மேலும் படிக்க",
    "learn_more": "மேலும் அறிய",
    "last_updated": "கடைசியாக புதுப்பிக்கப்பட்டது",
    "beginner": "அடிப்படை",
    "detailed": "விரிவானது",
    "advanced": "மேம்பட்டது",
    "faq": "அடிக்கடி கேட்கப்படும் கேள்விகள்",
    "references": "ஆதாரங்கள் மற்றும் குறிப்புகள்",
    "related": "தொடர்புடைய தலைப்புகள்",
    "book_title": "உங்கள் விசாரணையைத் தொடங்குங்கள்",
    "book_sub": "சில விவரங்களை பகிர்ந்து, வாட்ஸ்அப்பில் உரையாடலைத் தொடரவும்.",
    "field_name": "உங்கள் பெயர்",
    "field_location": "இடம் (நகரம் / நாடு)",
    "field_phone": "தொலைபேசி (விரும்பினால்)",
    "field_birth": "பிறப்பு விவரங்கள் - தேதி, நேரம், இடம் (விரும்பினால்)",
    "field_concern": "உங்கள் பிரச்சனையை சுருக்கமாக விவரிக்கவும்",
    "field_service": "சேவை / பிரச்சனை",
    "submit_whatsapp": "அனுப்பி வாட்ஸ்அப்பைத் திறக்க",
    "submitting": "தயாராகிறது...",
    "book_success": "வாட்ஸ்அப் திறக்கப்படுகிறது - உங்கள் விவரங்கள் அனுப்பத் தயார்.",
    "required": "தயவுசெய்து உங்கள் பெயரை உள்ளிடவும்.",
    "footer_tagline": "தாராபீத்திற்கு முன்னுரிமை அளிக்கும் ஆன்மீக அறிவு மற்றும் வழிகாட்டுதல் தளம்.",
    "footer_explore": "ஆராய்க",
    "footer_knowledge": "அறிவுத் தூண்கள்",
    "footer_legal": "நம்பிக்கை மற்றும் கொள்கைகள்",
    "footer_connect": "தொடர்புக்கு",
    "privacy": "தனியுரிமைக் கொள்கை",
    "terms": "விதிமுறைகள் மற்றும் நிபந்தனைகள்",
    "disclaimer": "பொறுப்புத்துறப்பு",
    "editorial": "தலையங்கக் கொள்கை",
    "rights": "அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.",
    "disclaimer_short": "ஆன்மீக மற்றும் பாரம்பரிய நடைமுறைகள் மரியாதையுடன் வழங்கப்படுகின்றன, இவை தகுதிவாய்ந்த மருத்துவ, மனநல, சட்ட அல்லது நிதி ஆலோசனைகளுக்கு மாற்றாகாது. எந்தவொரு குறிப்பிட்ட முடிவுக்கும் உத்தரவாதமில்லை.",
    "nav_festivals": "பண்டிகை நாள்காட்டி",
    "festivals_eyebrow": "புனித சந்திர நாள்காட்டி",
    "festivals_title": "வரவிருக்கும் அமாவாசை மற்றும் பண்டிகை தேதிகள்",
    "festivals_sub": "சந்திர நாள்காட்டியிலிருந்து கணக்கிடப்பட்ட அமாவாசை, கௌசிகி அமாவாசை மற்றும் பௌர்ணமி தேதிகள். எந்தவொரு நிகழ்விற்கும் பூஜையை ஒரே தட்டலில் முன்பதிவு செய்யலாம்.",
    "festival_book": "இந்த தேதிக்காக விசாரிக்கவும்",
    "view_all_dates": "முழு நாள்காட்டியைப் பார்க்க",
    "days_away": "நாட்களில்",
    "today": "இன்று",
    "tomorrow": "நாளை",
    "next_observance": "அடுத்த நிகழ்வு",
    "note": "குறிப்பு",
    "festivals_disclaimer": "தேதிகள் இந்திய நேரப்படி சந்திர சுழற்சியிலிருந்து கணக்கிடப்படுகின்றன, உங்கள் உள்ளூர் பஞ்சாங்கத்திலிருந்து ஒரு நாள் மாறுபடலாம். பயணிப்பதற்கு முன் சிவம் சாட்டர்ஜியிடம் சரியான முகூர்த்தத்தை உறுதிப்படுத்திக் கொள்ளவும்.",
    "voices_eyebrow": "பக்தர்களின் குரல்கள்",
    "voices_title": "அவர்களின் வார்த்தைகளில்",
    "translate_title": "உங்கள் மொழியைத் தேர்ந்தெடுக்கவும்",
    "translate_sub": "TarapithTantrik தளத்தை உங்களுக்கு மிகவும் வசதியான மொழியில் படிக்கவும்.",
    "translate_search": "மொழியைத் தேட",
    "translate_note": "பெங்காலி மற்றும் இந்தி எங்கள் குழுவால் மதிப்பாய்வு செய்யப்படுகிறது. பிற மொழிகள் இயந்திரத்தின் உதவியுடன் மொழிபெயர்க்கப்பட்டு தொடர்ந்து மேம்படுத்தப்படுகின்றன.",
    "no_results": "உங்கள் தேடலுக்கு எந்த மொழியும் பொருந்தவில்லை.",
    "ai_translated": "இயந்திர மொழிபெயர்ப்பு"
  },
  "te": {
    "nav_home": "హోమ్",
    "nav_services": "సేవలు",
    "nav_knowledge": "జ్ఞానం",
    "nav_concerns": "జీవిత సమస్యలు",
    "nav_visit": "తారాపీఠ్ దర్శనం",
    "nav_about": "శివమ్ గురించి",
    "nav_contact": "సంప్రదించండి",
    "cta_book": "పూజ బుక్ చేయండి",
    "cta_speak": "శివమ్ ఛటర్జీతో మాట్లాడండి",
    "cta_request": "మార్గదర్శకత్వం కోరండి",
    "cta_discuss": "మీ సమస్యను చర్చించండి",
    "cta_enquire": "పూజ గురించి విచారించండి",
    "cta_whatsapp": "వాట్సాప్ లో కొనసాగించండి",
    "cta_explore": "జ్ఞాన కేంద్రాన్ని అన్వేషించండి",
    "hero_eyebrow": "తారాపీఠ్ తంత్ర యొక్క పవిత్ర ప్రామాణికత",
    "hero_title": "తారాపీఠ్ మా తారా",
    "hero_subtitle": "తారాపీఠ్ తంత్ర, మా తారా సాధన, దశమహావిద్య మరియు శాక్తేయ సాంప్రదాయాలకు ఒక లోతైన, ప్రామాణికమైన గమ్యస్థానం — శివమ్ ఛటర్జీ గారి గౌరవప్రదమైన ఆధ్యాత్మిక మార్గదర్శకత్వం, పూజ మరియు హవనాలతో.",
    "services_eyebrow": "మీ సమస్యను ఎంచుకోండి",
    "services_title": "మేము మీకు ఎలా మార్గనిర్దేశం చేయగలం?",
    "services_sub": "వాట్సాప్ ద్వారా విచారణ ప్రారంభించడానికి ఒక సమస్యను లేదా మా తారా సేవను ఎంచుకోండి.",
    "pillars_eyebrow": "లోతైన జ్ఞాన వ్యవస్థ",
    "pillars_title": "తారాపీఠ్ జ్ఞాన కేంద్రం",
    "pillars_sub": "తారాపీఠ్ మరియు తంత్ర సాంప్రదాయాలపై ప్రాథమిక నుండి ఉన్నత స్థాయి వరకు అవగాహన.",
    "concerns_eyebrow": "జీవిత సమస్యలు & మార్గదర్శకత్వం",
    "concerns_title": "జీవితంలోని నిజమైన సమస్యలకు మార్గదర్శకత్వం",
    "read_more": "మరింత చదవండి",
    "learn_more": "మరింత తెలుసుకోండి",
    "last_updated": "చివరిగా అప్‌డేట్ చేయబడినది",
    "beginner": "ప్రాథమికం",
    "detailed": "వివరణాత్మకం",
    "advanced": "ఉన్నత స్థాయి",
    "faq": "తరచుగా అడిగే ప్రశ్నలు",
    "references": "మూలాలు & ఉల్లేఖనాలు",
    "related": "సంబంధిత అంశాలు",
    "book_title": "మీ మార్గదర్శక విచారణను ప్రారంభించండి",
    "book_sub": "కొన్ని వివరాలను పంచుకోండి మరియు వాట్సాప్ ద్వారా సంభాషణను కొనసాగించండి.",
    "field_name": "మీ పేరు",
    "field_location": "ప్రాంతం (నగరం / దేశం)",
    "field_phone": "ఫోన్ నంబర్ (ఐచ్ఛికం)",
    "field_birth": "జనన వివరాలు — తేదీ, సమయం, స్థలం (ఐచ్ఛికం)",
    "field_concern": "మీ సమస్యను క్లుప్తంగా వివరించండి",
    "field_service": "సేవ / సమస్య",
    "submit_whatsapp": "పంపండి & వాట్సాప్ తెరవండి",
    "submitting": "సిద్ధం చేస్తోంది...",
    "book_success": "వాట్సాప్ తెరుచుకుంటోంది — మీ వివరాలు పంపడానికి సిద్ధంగా ఉన్నాయి.",
    "required": "దయచేసి మీ పేరును నమోదు చేయండి.",
    "footer_tagline": "తారాపీఠ్ కు ప్రాధాన్యతనిచ్చే ఆధ్యాత్మిక జ్ఞాన మరియు మార్గదర్శక వేదిక.",
    "footer_explore": "అన్వేషించండి",
    "footer_knowledge": "జ్ఞాన మూలస్తంభాలు",
    "footer_legal": "విశ్వాసం & విధానాలు",
    "footer_connect": "సంప్రదించండి",
    "privacy": "గోప్యతా విధానం",
    "terms": "నిబంధనలు & షరతులు",
    "disclaimer": "నిరాకరణ",
    "editorial": "ఎడిటోరియల్ విధానం",
    "rights": "అన్ని హక్కులూ ప్రత్యేకించబడినవి.",
    "disclaimer_short": "ఆధ్యాత్మిక మరియు సాంప్రదాయ పద్ధతులు గౌరవప్రదంగా అందించబడతాయి, ఇవి అర్హత కలిగిన వైద్య, మానసిక-ఆరోగ్య, చట్టపరమైన లేదా ఆర్థిక సలహాలకు ప్రత్యామ్నాయం కావు. నిర్దిష్ట ఫలితానికి ఎటువంటి హామీ లేదు.",
    "nav_festivals": "పండుగల క్యాలెండర్",
    "festivals_eyebrow": "పవిత్ర చంద్రమాన క్యాలెండర్",
    "festivals_title": "రాబోయే అమావాస్య & పండుగల తేదీలు",
    "festivals_sub": "చంద్రమాన క్యాలెండర్ ప్రకారం అమావాస్య, కౌశికి అమావాస్య మరియు పూర్ణిమ తేదీలు లెక్కించబడ్డాయి. ఏదైనా పర్వదినం కోసం ఒకే ట్యాప్‌లో పూజను బుక్ చేయండి.",
    "festival_book": "ఈ తేదీ కోసం విచారించండి",
    "view_all_dates": "పూర్తి క్యాలెండర్‌ను చూడండి",
    "days_away": "రోజులు ఉన్నాయి",
    "today": "ఈరోజు",
    "tomorrow": "రేపు",
    "next_observance": "తదుపరి పర్వదినం",
    "note": "గమనిక",
    "festivals_disclaimer": "తేదీలు భారత కాలమానం ప్రకారం చంద్రమాన చక్రం నుండి లెక్కించబడ్డాయి, కాబట్టి మీ స్థానిక పంచాంగానికి ఒక రోజు తేడా ఉండవచ్చు. ప్రయాణించే ముందు దయచేసి శివమ్ ఛటర్జీతో ఖచ్చితమైన ముహూర్తాన్ని నిర్ధారించుకోండి.",
    "voices_eyebrow": "భక్తుల స్వరాలు",
    "voices_title": "వారి మాటల్లో",
    "translate_title": "మీ భాషను ఎంచుకోండి",
    "translate_sub": "మీకు అత్యంత అనుకూలమైన భాషలో TarapithTantrik ను చదవండి.",
    "translate_search": "భాషను శోధించండి",
    "translate_note": "బెంగాలీ మరియు హిందీ మా బృందం ద్వారా సమీక్షించబడతాయి. ఇతర భాషలు యంత్ర సహాయంతో అనువదించబడతాయి మరియు నిరంతరం మెరుగుపరచబడతాయి.",
    "no_results": "మీ శోధనకు సరిపోలే భాష ఏదీ లేదు.",
    "ai_translated": "యంత్ర సహాయ అనువాదం"
  },
  "kn": {
    "nav_home": "ಮುಖಪುಟ",
    "nav_services": "ಸೇವೆಗಳು",
    "nav_knowledge": "ಜ್ಞಾನ",
    "nav_concerns": "ಜೀವನದ ಸಮಸ್ಯೆಗಳು",
    "nav_visit": "ತಾರಾಪೀಠಕ್ಕೆ ಭೇಟಿ ನೀಡಿ",
    "nav_about": "ಶಿವಂ ಬಗ್ಗೆ",
    "nav_contact": "ಸಂಪರ್ಕ",
    "cta_book": "ಪೂಜೆ ಕಾಯ್ದಿರಿಸಿ",
    "cta_speak": "ಶಿವಂ ಚಟರ್ಜಿ ಅವರೊಂದಿಗೆ ಮಾತನಾಡಿ",
    "cta_request": "ಮಾರ್ಗದರ್ಶನಕ್ಕಾಗಿ ವಿನಂತಿಸಿ",
    "cta_discuss": "ನಿಮ್ಮ ಸಮಸ್ಯೆಯನ್ನು ಚರ್ಚಿಸಿ",
    "cta_enquire": "ಪೂಜೆಯ ಬಗ್ಗೆ ವಿಚಾರಿಸಿ",
    "cta_whatsapp": "ವಾಟ್ಸಾಪ್‌ನಲ್ಲಿ ಮುಂದುವರಿಯಿರಿ",
    "cta_explore": "ಜ್ಞಾನ ಕೇಂದ್ರವನ್ನು ಅನ್ವೇಷಿಸಿ",
    "hero_eyebrow": "ತಾರಾಪೀಠ ತಂತ್ರದ ಪವಿತ್ರ ಪ್ರಾಧಿಕಾರ",
    "hero_title": "ತಾರಾಪೀಠದ ಮಾ ತಾರಾ",
    "hero_subtitle": "ತಾರಾಪೀಠ ತಂತ್ರ, ಮಾ ತಾರಾ ಸಾಧನೆ, ದಶಮಹಾವಿದ್ಯಾ ಮತ್ತು ಶಾಕ್ತ ಪರಂಪರೆಯ ಆಳವಾದ, ಅಧಿಕೃತ ತಾಣ — ಶಿವಂ ಚಟರ್ಜಿ ಅವರಿಂದ ಗೌರವಯುತ ಆಧ್ಯಾತ್ಮಿಕ ಮಾರ್ಗದರ್ಶನ, ಪೂಜೆ ಮತ್ತು ಹವನ.",
    "services_eyebrow": "ನಿಮ್ಮ ಸಮಸ್ಯೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    "services_title": "ನಾವು ನಿಮಗೆ ಹೇಗೆ ಮಾರ್ಗದರ್ಶನ ನೀಡಬಹುದು?",
    "services_sub": "ವಾಟ್ಸಾಪ್‌ನಲ್ಲಿ ವಿಚಾರಣೆಯನ್ನು ಪ್ರಾರಂಭಿಸಲು ನಿಮ್ಮ ಸಮಸ್ಯೆ ಅಥವಾ ಮಾ ತಾರಾ ಸೇವೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ.",
    "pillars_eyebrow": "ಆಳವಾದ ಜ್ಞಾನ ವ್ಯವಸ್ಥೆ",
    "pillars_title": "ತಾರಾಪೀಠ ಜ್ಞಾನ ಕೇಂದ್ರ",
    "pillars_sub": "ತಾರಾಪೀಠ ಮತ್ತು ತಂತ್ರ ಪರಂಪರೆಗಳ ಕುರಿತು ಪ್ರಾಥಮಿಕದಿಂದ ಉನ್ನತ ಮಟ್ಟದವರೆಗಿನ ತಿಳುವಳಿಕೆ.",
    "concerns_eyebrow": "ಜೀವನದ ಸಮಸ್ಯೆಗಳು ಮತ್ತು ಮಾರ್ಗದರ್ಶನ",
    "concerns_title": "ಜೀವನದ ನೈಜ ಸಮಸ್ಯೆಗಳಿಗೆ ಮಾರ್ಗದರ್ಶನ",
    "read_more": "ಇನ್ನಷ್ಟು ಓದಿ",
    "learn_more": "ಹೆಚ್ಚಿನ ಮಾಹಿತಿ",
    "last_updated": "ಕೊನೆಯದಾಗಿ ನವೀಕರಿಸಿದ್ದು",
    "beginner": "ಆರಂಭಿಕ",
    "detailed": "ವಿವರವಾದ",
    "advanced": "ಉನ್ನತ",
    "faq": "ಪದೇ ಪದೇ ಕೇಳಲಾಗುವ ಪ್ರಶ್ನೆಗಳು",
    "references": "ಮೂಲಗಳು ಮತ್ತು ಉಲ್ಲೇಖಗಳು",
    "related": "ಸಂಬಂಧಿತ ವಿಷಯಗಳು",
    "book_title": "ನಿಮ್ಮ ವಿಚಾರಣೆಯನ್ನು ಪ್ರಾರಂಭಿಸಿ",
    "book_sub": "ಕೆಲವು ವಿವರಗಳನ್ನು ಹಂಚಿಕೊಳ್ಳಿ ಮತ್ತು ನೇರವಾಗಿ ವಾಟ್ಸಾಪ್‌ನಲ್ಲಿ ಮಾತುಕತೆ ಮುಂದುವರಿಸಿ.",
    "field_name": "ನಿಮ್ಮ ಹೆಸರು",
    "field_location": "ಸ್ಥಳ (ನಗರ / ದೇಶ)",
    "field_phone": "ಫೋನ್ ಸಂಖ್ಯೆ (ಐಚ್ಛಿಕ)",
    "field_birth": "ಜನನ ವಿವರಗಳು — ದಿನಾಂಕ, ಸಮಯ, ಸ್ಥಳ (ಐಚ್ಛಿಕ)",
    "field_concern": "ನಿಮ್ಮ ಸಮಸ್ಯೆಯನ್ನು ಸಂಕ್ಷಿಪ್ತವಾಗಿ ವಿವರಿಸಿ",
    "field_service": "ಸೇವೆ / ಸಮಸ್ಯೆ",
    "submit_whatsapp": "ಕಳುಹಿಸಿ ಮತ್ತು ವಾಟ್ಸಾಪ್ ತೆರೆಯಿರಿ",
    "submitting": "ಸಿದ್ಧಪಡಿಸಲಾಗುತ್ತಿದೆ...",
    "book_success": "ವಾಟ್ಸಾಪ್ ತೆರೆಯಲಾಗುತ್ತಿದೆ — ನಿಮ್ಮ ವಿವರಗಳನ್ನು ಕಳುಹಿಸಲು ಸಿದ್ಧವಾಗಿದೆ.",
    "required": "ದಯವಿಟ್ಟು ನಿಮ್ಮ ಹೆಸರನ್ನು ನಮೂದಿಸಿ.",
    "footer_tagline": "ತಾರಾಪೀಠ-ಪ್ರಧಾನ ಆಧ್ಯಾತ್ಮಿಕ ಜ್ಞಾನ ಮತ್ತು ಮಾರ್ಗದರ್ಶನ ವೇದಿಕೆ.",
    "footer_explore": "ಅನ್ವೇಷಿಸಿ",
    "footer_knowledge": "ಜ್ಞಾನದ ಆಧಾರಗಳು",
    "footer_legal": "ನಂಬಿಕೆ ಮತ್ತು ನೀತಿಗಳು",
    "footer_connect": "ಸಂಪರ್ಕಿಸಿ",
    "privacy": "ಗೌಪ್ಯತಾ ನೀತಿ",
    "terms": "ನಿಯಮಗಳು ಮತ್ತು ನಿಬಂಧನೆಗಳು",
    "disclaimer": "ಹಕ್ಕು ನಿರಾಕರಣೆ",
    "editorial": "ಸಂಪಾದಕೀಯ ನೀತಿ",
    "rights": "ಎಲ್ಲಾ ಹಕ್ಕುಗಳನ್ನು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ.",
    "disclaimer_short": "ಆಧ್ಯಾತ್ಮಿಕ ಮತ್ತು ಸಾಂಪ್ರದಾಯಿಕ ಆಚರಣೆಗಳನ್ನು ಗೌರವಯುತವಾಗಿ ನೀಡಲಾಗುತ್ತದೆ. ಇವು ವೈದ್ಯಕೀಯ, ಮಾನಸಿಕ ಆರೋಗ್ಯ, ಕಾನೂನು ಅಥವಾ ಆರ್ಥಿಕ ಸಲಹೆಗಳಿಗೆ ಪರ್ಯಾಯವಲ್ಲ. ಯಾವುದೇ ನಿರ್ದಿಷ್ಟ ಫಲಿತಾಂಶವನ್ನು ಖಾತರಿಪಡಿಸುವುದಿಲ್ಲ.",
    "nav_festivals": "ಹಬ್ಬಗಳ ಪಂಚಾಂಗ",
    "festivals_eyebrow": "ಪವಿತ್ರ ಚಂದ್ರಮಾನ ಪಂಚಾಂಗ",
    "festivals_title": "ಮುಂಬರುವ ಅಮಾವಾಸ್ಯೆ ಮತ್ತು ಹಬ್ಬದ ದಿನಾಂಕಗಳು",
    "festivals_sub": "ಚಂದ್ರಮಾನ ಪಂಚಾಂಗದಿಂದ ಲೆಕ್ಕಾಚಾರ ಮಾಡಿದ ಅಮಾವಾಸ್ಯೆ, ಕೌಶಿಕಿ ಅಮಾವಾಸ್ಯೆ ಮತ್ತು ಹುಣ್ಣಿಮೆ ದಿನಾಂಕಗಳು. ಯಾವುದೇ ಆಚರಣೆಗಾಗಿ ಒಂದೇ ಟ್ಯಾಪ್‌ನಲ್ಲಿ ಪೂಜೆಯನ್ನು ಕಾಯ್ದಿರಿಸಿ.",
    "festival_book": "ಈ ದಿನಾಂಕಕ್ಕಾಗಿ ವಿಚಾರಿಸಿ",
    "view_all_dates": "ಸಂಪೂರ್ಣ ಕ್ಯಾಲೆಂಡರ್ ವೀಕ್ಷಿಸಿ",
    "days_away": "ದಿನಗಳು ಬಾಕಿ",
    "today": "ಇಂದು",
    "tomorrow": "ನಾಳೆ",
    "next_observance": "ಮುಂದಿನ ಆಚರಣೆ",
    "note": "ಸೂಚನೆ",
    "festivals_disclaimer": "ಭಾರತೀಯ ಕಾಲಮಾನದಲ್ಲಿ ಚಂದ್ರನ ಚಲನೆಯ ಆಧಾರದ ಮೇಲೆ ದಿನಾಂಕಗಳನ್ನು ಲೆಕ್ಕಹಾಕಲಾಗಿದೆ ಮತ್ತು ನಿಮ್ಮ ಸ್ಥಳೀಯ ಪಂಚಾಂಗಕ್ಕಿಂತ ಒಂದು ದಿನ ಭಿನ್ನವಾಗಿರಬಹುದು. ಪ್ರಯಾಣಿಸುವ ಮುನ್ನ ಶಿವಂ ಚಟರ್ಜಿ ಅವರೊಂದಿಗೆ ನಿಖರವಾದ ಮುಹೂರ್ತವನ್ನು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ.",
    "voices_eyebrow": "ಭಕ್ತರ ಧ್ವನಿ",
    "voices_title": "ಅವರ ಮಾತುಗಳಲ್ಲಿ",
    "translate_title": "ನಿಮ್ಮ ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    "translate_sub": "ನಿಮಗೆ ಹೆಚ್ಚು ಆರಾಮದಾಯಕವಾದ ಭಾಷೆಯಲ್ಲಿ 'TarapithTantrik' ಅನ್ನು ಓದಿ.",
    "translate_search": "ಭಾಷೆಯನ್ನು ಹುಡುಕಿ",
    "translate_note": "ಬಂಗಾಳಿ ಮತ್ತು ಹಿಂದಿ ಭಾಷೆಗಳನ್ನು ನಮ್ಮ ತಂಡವು ಪರಿಶೀಲಿಸುತ್ತದೆ. ಇತರ ಭಾಷೆಗಳು ಯಂತ್ರ-ಅನುವಾದಿತವಾಗಿದ್ದು, ನಿರಂತರವಾಗಿ ಸುಧಾರಿಸಲಾಗುತ್ತಿದೆ.",
    "no_results": "ನಿಮ್ಮ ಹುಡುಕಾಟಕ್ಕೆ ಯಾವುದೇ ಭಾಷೆ ಹೊಂದಿಕೆಯಾಗುವುದಿಲ್ಲ.",
    "ai_translated": "ಯಂತ್ರ-ಸಹಾಯದ ಅನುವಾದ"
  },
  "ml": {
    "nav_home": "ഹോം",
    "nav_services": "സേവനങ്ങൾ",
    "nav_knowledge": "വിജ്ഞാനം",
    "nav_concerns": "ജീവിത പ്രശ്നങ്ങൾ",
    "nav_visit": "താരാപീഠം സന്ദർശിക്കുക",
    "nav_about": "ശിവത്തിനെക്കുറിച്ച്",
    "nav_contact": "ബന്ധപ്പെടുക",
    "cta_book": "പൂജ ബുക്ക് ചെയ്യുക",
    "cta_speak": "ശിവം ചാറ്റർജിയോട് സംസാരിക്കുക",
    "cta_request": "മാർഗ്ഗനിർദ്ദേശം അഭ്യർത്ഥിക്കുക",
    "cta_discuss": "നിങ്ങളുടെ പ്രശ്നം ചർച്ച ചെയ്യുക",
    "cta_enquire": "പൂജയെക്കുറിച്ച് അന്വേഷിക്കുക",
    "cta_whatsapp": "വാട്സ്ആപ്പിൽ തുടരുക",
    "cta_explore": "വിജ്ഞാന കേന്ദ്രം പര്യവേക്ഷണം ചെയ്യുക",
    "hero_eyebrow": "താരാപീഠം തന്ത്രയുടെ പവിത്രമായ ആധികാരികത",
    "hero_title": "താരാപീഠത്തിലെ മാ താര",
    "hero_subtitle": "താരാപീഠം തന്ത്രം, മാ താര സാധന, ദശമഹാവിദ്യ, ശാക്തേയ പാരമ്പര്യം എന്നിവയ്ക്കായുള്ള ആധികാരിക ഇടം — ശിവം ചാറ്റർജിയുടെ ആദരപൂർവ്വമുള്ള ആത്മീയ മാർഗ്ഗനിർദ്ദേശങ്ങൾക്കും പൂജകൾക്കും ഹോമങ്ങൾക്കുമൊപ്പം.",
    "services_eyebrow": "നിങ്ങളുടെ പ്രശ്നം തിരഞ്ഞെടുക്കുക",
    "services_title": "ഞങ്ങൾക്ക് നിങ്ങളെ എങ്ങനെ സഹായിക്കാനാകും?",
    "services_sub": "വാട്സ്ആപ്പിലൂടെയുള്ള അന്വേഷണം ആരംഭിക്കുന്നതിനായി ഒരു പ്രശ്നമോ മാ താര സേവനമോ തിരഞ്ഞെടുക്കുക.",
    "pillars_eyebrow": "ആഴത്തിലുള്ള വിജ്ഞാന ശേഖരം",
    "pillars_title": "താരാപീഠം വിജ്ഞാന കേന്ദ്രം",
    "pillars_sub": "താരാപീഠം, തന്ത്ര പാരമ്പര്യങ്ങളെക്കുറിച്ചുള്ള പ്രാഥമിക തലം മുതൽ ഉന്നത തലം വരെയുള്ള അറിവുകൾ.",
    "concerns_eyebrow": "ജീവിത പ്രശ്നങ്ങളും മാർഗ്ഗനിർദ്ദേശങ്ങളും",
    "concerns_title": "ജീവിതത്തിലെ യാഥാർത്ഥ പ്രശ്നങ്ങൾക്കുള്ള മാർഗ്ഗനിർദ്ദേശം",
    "read_more": "കൂടുതൽ വായിക്കുക",
    "learn_more": "കൂടുതൽ അറിയുക",
    "last_updated": "അവസാനം പുതുക്കിയത്",
    "beginner": "തുടക്കക്കാർക്ക്",
    "detailed": "വിശദമായ",
    "advanced": "ഉന്നതമായ",
    "faq": "പതിവായി ചോദിക്കുന്ന ചോദ്യങ്ങൾ",
    "references": "ഉറവിടങ്ങളും അവലംബങ്ങളും",
    "related": "ബന്ധപ്പെട്ട വിഷയങ്ങൾ",
    "book_title": "നിങ്ങളുടെ അന്വേഷണം ആരംഭിക്കുക",
    "book_sub": "ചില വിവരങ്ങൾ പങ്കുവെച്ച് വാട്സ്ആപ്പിലൂടെ നേരിട്ട് സംഭാഷണം തുടരുക.",
    "field_name": "നിങ്ങളുടെ പേര്",
    "field_location": "സ്ഥലം (നഗരം / രാജ്യം)",
    "field_phone": "ഫോൺ നമ്പർ (നിർബന്ധമില്ല)",
    "field_birth": "ജനന വിവരങ്ങൾ — തീയതി, സമയം, സ്ഥലം (നിർബന്ധമില്ല)",
    "field_concern": "നിങ്ങളുടെ പ്രശ്നം ചുരുക്കത്തിൽ വിവരിക്കുക",
    "field_service": "സേവനം / പ്രശ്നം",
    "submit_whatsapp": "അയക്കുക & വാട്സ്ആപ്പ് തുറക്കുക",
    "submitting": "തയ്യാറാക്കുന്നു...",
    "book_success": "വാട്സ്ആപ്പ് തുറക്കുന്നു — നിങ്ങളുടെ വിവരങ്ങൾ അയക്കാൻ തയ്യാറാണ്.",
    "required": "ദയവായി നിങ്ങളുടെ പേര് നൽകുക.",
    "footer_tagline": "താരാപീഠത്തിന് പ്രാധാന്യം നൽകുന്ന ഒരു ആത്മീയ വിജ്ഞാന-മാർഗ്ഗനിർദ്ദേശ വേദി.",
    "footer_explore": "പര്യവേക്ഷണം ചെയ്യുക",
    "footer_knowledge": "വിജ്ഞാന സ്തംഭങ്ങൾ",
    "footer_legal": "വിശ്വാസ്യതയും നയങ്ങളും",
    "footer_connect": "ബന്ധപ്പെടുക",
    "privacy": "സ്വകാര്യതാ നയം",
    "terms": "നിബന്ധനകളും വ്യവസ്ഥകളും",
    "disclaimer": "നിരാകരണം",
    "editorial": "എഡിറ്റോറിയൽ നയം",
    "rights": "എല്ലാ അവകാശങ്ങളും നിക്ഷിപ്തം.",
    "disclaimer_short": "ആത്മീയവും പരമ്പരാഗതവുമായ ആചാരങ്ങൾ ആദരവോടെയാണ് നൽകുന്നത്, അവ ഒരിക്കലും ഒരു വിദഗ്ദ്ധ ഡോക്ടറുടെയോ മാനസികാരോഗ്യ വിദഗ്ദ്ധന്റെയോ നിയമ-സാമ്പത്തിക ഉപദേഷ്ടാക്കളുടെയോ ഉപദേശത്തിന് പകരമാവില്ല. ഒരു പ്രത്യേക ഫലവും ഞങ്ങൾ ഉറപ്പുനൽകുന്നില്ല.",
    "nav_festivals": "ഉത്സവ കലണ്ടർ",
    "festivals_eyebrow": "പവിത്രമായ ചാന്ദ്ര കലണ്ടർ",
    "festivals_title": "വരാനിരിക്കുന്ന അമാവാസി, ഉത്സവ തീയതികൾ",
    "festivals_sub": "ചാന്ദ്ര കലണ്ടർ പ്രകാരം കണക്കാക്കിയ അമാവാസി, കൗശികി അമാവാസി, പൗർണ്ണമി തീയതികൾ. ഏത് വിശേഷ ദിവസത്തേക്കുമുള്ള പൂജ ഒറ്റ ക്ലിക്കിൽ ബുക്ക് ചെയ്യുക.",
    "festival_book": "ഈ തീയതിക്കായി അന്വേഷിക്കുക",
    "view_all_dates": "മുഴുവൻ കലണ്ടറും കാണുക",
    "days_away": "ദിവസങ്ങൾ അകലെ",
    "today": "ഇന്ന്",
    "tomorrow": "നാളെ",
    "next_observance": "അടുത്ത വിശേഷ ദിവസം",
    "note": "ശ്രദ്ധിക്കുക",
    "festivals_disclaimer": "തീയതികൾ ഇന്ത്യൻ സ്റ്റാൻഡേർഡ് സമയത്തിലെ ചാന്ദ്ര ചക്രത്തിൽ നിന്ന് കണക്കാക്കിയതാണ്, നിങ്ങളുടെ പ്രദേശത്തെ പഞ്ചാംഗത്തിൽ നിന്ന് ഒരു ദിവസത്തെ വ്യത്യാസമുണ്ടാകാം. യാത്ര തിരിക്കുന്നതിന് മുമ്പ് ശിവം ചാറ്റർജിയുമായി കൃത്യമായ മുഹൂർത്തം ദയവായി ഉറപ്പുവരുത്തുക.",
    "voices_eyebrow": "ഭക്തരുടെ ശബ്ദം",
    "voices_title": "അവരുടെ വാക്കുകളിൽ",
    "translate_title": "നിങ്ങളുടെ ഭാഷ തിരഞ്ഞെടുക്കുക",
    "translate_sub": "നിങ്ങൾക്ക് ഏറ്റവും സൗകര്യപ്രദമായ ഭാഷയിൽ താരാപീഠം താന്ത്രിക് വായിക്കുക.",
    "translate_search": "ഒരു ഭാഷ തിരയുക",
    "translate_note": "ബംഗാളി, ഹിന്ദി ഭാഷകൾ ഞങ്ങളുടെ ടീം അവലോകനം ചെയ്തിട്ടുണ്ട്. മറ്റ് ഭാഷകൾ മെഷീൻ സഹായത്തോടെ വിവർത്തനം ചെയ്തവയാണ്, അവ നിരന്തരം മെച്ചപ്പെടുത്തിക്കൊണ്ടിരിക്കുന്നു.",
    "no_results": "നിങ്ങൾ തിരഞ്ഞ ഭാഷ കണ്ടെത്താനായില്ല.",
    "ai_translated": "മെഷീൻ സഹായത്തോടെയുള്ള വിവർത്തനം"
  },
  "ur": {
    "nav_home": "مرکزی صفحہ",
    "nav_services": "خدمات",
    "nav_knowledge": "علم",
    "nav_concerns": "زندگی کے مسائل",
    "nav_visit": "تاراپیٹھ کی زیارت",
    "nav_about": "شیوم کے بارے میں",
    "nav_contact": "رابطہ کریں",
    "cta_book": "پوجا بُک کریں",
    "cta_speak": "شیوم چٹرجی سے بات کریں",
    "cta_request": "رہنمائی کی درخواست کریں",
    "cta_discuss": "اپنے مسئلے پر بات کریں",
    "cta_enquire": "پوجا کے بارے میں دریافت کریں",
    "cta_whatsapp": "واٹس ایپ پر جاری رکھیں",
    "cta_explore": "علم کا مرکز دریافت کریں",
    "hero_eyebrow": "تاراپیٹھ تنتر کا مقدس مرکز",
    "hero_title": "تاراپیٹھ کی ماں تارا",
    "hero_subtitle": "تاراپیٹھ تنتر، ماں تارا سادھنا، دشا مہاودیا اور شاکت روایت کے لیے ایک گہرا اور مستند مقام — شیوم چٹرجی کی جانب سے پروقار روحانی رہنمائی، پوجا اور ہون کے ساتھ۔",
    "services_eyebrow": "اپنا مسئلہ منتخب کریں",
    "services_title": "ہم آپ کی رہنمائی کیسے کر سکتے ہیں؟",
    "services_sub": "رہنمائی کے ساتھ واٹس ایپ انکوائری شروع کرنے کے لیے کوئی مسئلہ یا ماں تارا کی خدمت منتخب کریں۔",
    "pillars_eyebrow": "علم کا وسیع مرکز",
    "pillars_title": "تاراپیٹھ کے علم کا مرکز",
    "pillars_sub": "تاراپیٹھ اور تنتر کی روایات کی ابتدائی سے لے کر اعلیٰ سطح تک کی تفہیم۔",
    "concerns_eyebrow": "زندگی کے مسائل اور رہنمائی",
    "concerns_title": "زندگی کے حقیقی مسائل کے لیے رہنمائی",
    "read_more": "مزید پڑھیں",
    "learn_more": "مزید جانیں",
    "last_updated": "آخری اپ ڈیٹ",
    "beginner": "ابتدائی",
    "detailed": "تفصیلی",
    "advanced": "اعلیٰ",
    "faq": "اکثر پوچھے گئے سوالات",
    "references": "ذرائع اور حوالہ جات",
    "related": "متعلقہ موضوعات",
    "book_title": "اپنی رہنمائی پر مبنی انکوائری شروع کریں",
    "book_sub": "چند تفصیلات شیئر کریں اور واٹس ایپ پر براہ راست بات چیت جاری رکھیں۔",
    "field_name": "آپ کا نام",
    "field_location": "مقام (شہر / ملک)",
    "field_phone": "فون (اختیاری)",
    "field_birth": "پیدائش کی تفصیلات — تاریخ، وقت، مقام (اختیاری)",
    "field_concern": "اپنے مسئلے کو مختصراً بیان کریں",
    "field_service": "خدمت / مسئلہ",
    "submit_whatsapp": "بھیجیں اور واٹس ایپ کھولیں",
    "submitting": "تیاری ہو رہی ہے...",
    "book_success": "واٹس ایپ کھل رہا ہے — آپ کی تفصیلات بھیجنے کے لیے تیار ہیں۔",
    "required": "براہ کرم اپنا نام درج کریں۔",
    "footer_tagline": "تاراپیٹھ کا اولین روحانی علم اور رہنمائی کا پلیٹ فارم۔",
    "footer_explore": "دریافت کریں",
    "footer_knowledge": "علم کے ستون",
    "footer_legal": "اعتماد اور پالیسیاں",
    "footer_connect": "رابطہ کریں",
    "privacy": "رازداری کی پالیسی",
    "terms": "شرائط و ضوابط",
    "disclaimer": "دستبرداری",
    "editorial": "ادارتی پالیسی",
    "rights": "جملہ حقوق محفوظ ہیں۔",
    "disclaimer_short": "روحانی اور روایتی عبادات احترام کے ساتھ پیش کی جاتی ہیں اور یہ مستند طبی، نفسیاتی، قانونی یا مالیاتی مشورے کا متبادل نہیں ہیں۔ کسی خاص نتیجے کی ضمانت نہیں دی جا سکتی۔",
    "nav_festivals": "تہواروں کا کیلنڈر",
    "festivals_eyebrow": "مقدس قمری کیلنڈر",
    "festivals_title": "آئندہ اماوسیا اور تہواروں کی تاریخیں",
    "festivals_sub": "قمری کیلنڈر سے شمار کی گئی اماوسیا، کوشکی اماوسیا اور پورنیما کی تاریخیں۔ کسی بھی تقریب کے لیے ایک کلک سے پوجا بُک کریں۔",
    "festival_book": "اس تاریخ کے لیے دریافت کریں",
    "view_all_dates": "مکمل کیلنڈر دیکھیں",
    "days_away": "دن باقی",
    "today": "آج",
    "tomorrow": "کل",
    "next_observance": "اگلی تقریب",
    "note": "نوٹ",
    "festivals_disclaimer": "تاریخیں انڈین اسٹینڈرڈ ٹائم (IST) کے مطابق قمری چکر سے شمار کی گئی ہیں اور آپ کے مقامی پنچانگ سے ایک دن کا فرق ہو سکتا ہے۔ سفر کرنے سے پہلے براہ کرم شیوم چٹرجی سے درست مہورت کی تصدیق کر لیں۔",
    "voices_eyebrow": "عقیدت مندوں کی آراء",
    "voices_title": "ان کے الفاظ میں",
    "translate_title": "اپنی زبان کا انتخاب کریں",
    "translate_sub": "جس زبان میں آپ کو آسانی ہو، اس میں تاراپیٹھ تانترک پڑھیں۔",
    "translate_search": "زبان تلاش کریں",
    "translate_note": "بنگالی اور ہندی کا ہماری ٹیم کے ذریعے جائزہ لیا گیا ہے۔ دیگر زبانیں مشین کی مدد سے تیار کی گئی ہیں اور ان میں مسلسل بہتری لائی جا رہی ہے۔",
    "no_results": "آپ کی تلاش کے مطابق کوئی زبان نہیں ملی۔",
    "ai_translated": "مشین کی مدد سے ترجمہ"
  },
  "es": {
    "nav_home": "Inicio",
    "nav_services": "Servicios",
    "nav_knowledge": "Conocimiento",
    "nav_concerns": "Inquietudes de la Vida",
    "nav_visit": "Visitar Tarapith",
    "nav_about": "Sobre Shivam",
    "nav_contact": "Contacto",
    "cta_book": "Reservar una Puja",
    "cta_speak": "Hablar con Shivam Chatterjee",
    "cta_request": "Solicitar Orientación",
    "cta_discuss": "Consultar su Inquietud",
    "cta_enquire": "Consultar sobre una Puja",
    "cta_whatsapp": "Continuar en WhatsApp",
    "cta_explore": "Explorar el Centro de Conocimiento",
    "hero_eyebrow": "Autoridad Sagrada del Tantra de Tarapith",
    "hero_title": "Maa Tara de Tarapith",
    "hero_subtitle": "Un destino profundo y autorizado para el Tantra de Tarapith, el sadhana a Maa Tara, las Dashamahavidya y la tradición Shakta — con orientación espiritual respetuosa, puja y havan a cargo de Shivam Chatterjee.",
    "services_eyebrow": "Seleccione su Inquietud",
    "services_title": "¿Cómo podemos orientarle?",
    "services_sub": "Elija una inquietud o un servicio a Maa Tara para iniciar una consulta guiada por WhatsApp.",
    "pillars_eyebrow": "Ecosistema de Conocimiento Profundo",
    "pillars_title": "El Centro de Conocimiento de Tarapith",
    "pillars_sub": "Comprensión desde nivel principiante hasta avanzado sobre las tradiciones de Tarapith y el Tantra.",
    "concerns_eyebrow": "Inquietudes de la Vida y Orientación",
    "concerns_title": "Orientación para Inquietudes Reales de la Vida",
    "read_more": "Leer más",
    "learn_more": "Más información",
    "last_updated": "Última actualización",
    "beginner": "Principiante",
    "detailed": "Detallado",
    "advanced": "Avanzado",
    "faq": "Preguntas Frecuentes",
    "references": "Fuentes y Referencias",
    "related": "Temas Relacionados",
    "book_title": "Inicie su Consulta Guiada",
    "book_sub": "Comparta algunos detalles y continúe la conversación directamente en WhatsApp.",
    "field_name": "Su Nombre",
    "field_location": "Ubicación (Ciudad / País)",
    "field_phone": "Teléfono (opcional)",
    "field_birth": "Datos de nacimiento: fecha, hora, lugar (opcional)",
    "field_concern": "Describa brevemente su inquietud",
    "field_service": "Servicio / Inquietud",
    "submit_whatsapp": "Enviar y abrir WhatsApp",
    "submitting": "Preparando...",
    "book_success": "Abriendo WhatsApp: sus datos están listos para enviarse.",
    "required": "Por favor, introduzca su nombre.",
    "footer_tagline": "Una plataforma de orientación y conocimiento espiritual dedicada a Tarapith.",
    "footer_explore": "Explorar",
    "footer_knowledge": "Pilares de Conocimiento",
    "footer_legal": "Confianza y Políticas",
    "footer_connect": "Conectar",
    "privacy": "Política de Privacidad",
    "terms": "Términos y Condiciones",
    "disclaimer": "Descargo de Responsabilidad",
    "editorial": "Política Editorial",
    "rights": "Todos los derechos reservados.",
    "disclaimer_short": "Las prácticas espirituales y tradicionales se ofrecen con respeto y no sustituyen el asesoramiento médico, psicológico, legal o financiero calificado. No se garantiza ningún resultado específico.",
    "nav_festivals": "Calendario de Festivales",
    "festivals_eyebrow": "Calendario Lunar Sagrado",
    "festivals_title": "Próximas Fechas de Amavasya y Festivales",
    "festivals_sub": "Fechas de Amavasya, Kaushiki Amavasya y Purnima calculadas según el calendario lunar. Reserve una puja para cualquier celebración con un solo clic.",
    "festival_book": "Consultar para esta fecha",
    "view_all_dates": "Ver calendario completo",
    "days_away": "días restantes",
    "today": "Hoy",
    "tomorrow": "Mañana",
    "next_observance": "Próxima celebración",
    "note": "Nota",
    "festivals_disclaimer": "Las fechas se calculan según el ciclo lunar en la Hora Estándar de la India y pueden diferir en un día de su panchang local. Por favor, confirme el muhurta exacto con Shivam Chatterjee antes de viajar.",
    "voices_eyebrow": "Voces de los Devotos",
    "voices_title": "En Sus Propias Palabras",
    "translate_title": "Elija su idioma",
    "translate_sub": "Lea TarapithTantrik en el idioma que le resulte más cómodo.",
    "translate_search": "Buscar un idioma",
    "translate_note": "El bengalí y el hindi son revisados por nuestro equipo. Otros idiomas cuentan con asistencia automática y se mejoran continuamente.",
    "no_results": "Ningún idioma coincide con su búsqueda.",
    "ai_translated": "Traducción automática"
  },
  "fr": {
    "nav_home": "Accueil",
    "nav_services": "Services",
    "nav_knowledge": "Connaissances",
    "nav_concerns": "Préoccupations de la Vie",
    "nav_visit": "Visiter Tarapith",
    "nav_about": "À propos de Shivam",
    "nav_contact": "Contact",
    "cta_book": "Réserver une Puja",
    "cta_speak": "Parler avec Shivam Chatterjee",
    "cta_request": "Demander des Conseils",
    "cta_discuss": "Discuter de votre Préoccupation",
    "cta_enquire": "Se Renseigner sur une Puja",
    "cta_whatsapp": "Continuer sur WhatsApp",
    "cta_explore": "Explorer le Centre de Connaissances",
    "hero_eyebrow": "L'Autorité Sacrée du Tantra de Tarapith",
    "hero_title": "Maa Tara de Tarapith",
    "hero_subtitle": "Une destination approfondie et reconnue pour le Tantra de Tarapith, la sadhana de Maa Tara, le Dashamahavidya et la tradition Shakta — avec les conseils spirituels, la puja et le havan de Shivam Chatterjee.",
    "services_eyebrow": "Sélectionnez votre Préoccupation",
    "services_title": "Comment Pouvons-nous Vous Guider ?",
    "services_sub": "Choisissez une préoccupation ou un service de Maa Tara pour lancer une demande sur WhatsApp.",
    "pillars_eyebrow": "Écosystème de Connaissances Approfondi",
    "pillars_title": "Le Centre de Connaissances de Tarapith",
    "pillars_sub": "Compréhension de niveau débutant à avancé des traditions de Tarapith et du Tantra.",
    "concerns_eyebrow": "Préoccupations de la Vie & Conseils",
    "concerns_title": "Conseils pour les Vraies Préoccupations de la Vie",
    "read_more": "Lire la Suite",
    "learn_more": "En Savoir Plus",
    "last_updated": "Dernière mise à jour",
    "beginner": "Débutant",
    "detailed": "Détaillé",
    "advanced": "Avancé",
    "faq": "Foire Aux Questions",
    "references": "Sources & Références",
    "related": "Sujets Connexes",
    "book_title": "Commencer votre Demande Guidée",
    "book_sub": "Partagez quelques détails et continuez la conversation directement sur WhatsApp.",
    "field_name": "Votre Nom",
    "field_location": "Lieu (Ville / Pays)",
    "field_phone": "Téléphone (facultatif)",
    "field_birth": "Détails de naissance — date, heure, lieu (facultatif)",
    "field_concern": "Décrivez brièvement votre préoccupation",
    "field_service": "Service / Préoccupation",
    "submit_whatsapp": "Envoyer et Ouvrir WhatsApp",
    "submitting": "Préparation...",
    "book_success": "Ouverture de WhatsApp — vos détails sont prêts à être envoyés.",
    "required": "Veuillez entrer votre nom.",
    "footer_tagline": "Une plateforme spirituelle de connaissances et de conseils dédiée à Tarapith.",
    "footer_explore": "Explorer",
    "footer_knowledge": "Piliers de Connaissances",
    "footer_legal": "Confiance & Politiques",
    "footer_connect": "Se Connecter",
    "privacy": "Politique de Confidentialité",
    "terms": "Termes & Conditions",
    "disclaimer": "Avis de Non-Responsabilité",
    "editorial": "Politique Éditoriale",
    "rights": "Tous droits réservés.",
    "disclaimer_short": "Les pratiques spirituelles et traditionnelles sont proposées avec respect et ne remplacent pas un avis médical, psychologique, juridique ou financier qualifié. Aucun résultat spécifique n'est garanti.",
    "nav_festivals": "Calendrier des Fêtes",
    "festivals_eyebrow": "Calendrier Lunaire Sacré",
    "festivals_title": "Prochaines Dates d'Amavasya & de Fêtes",
    "festivals_sub": "Les dates d'Amavasya, de Kaushiki Amavasya et de Purnima sont calculées selon le calendrier lunaire. Réservez une puja pour toute célébration en un clic.",
    "festival_book": "Se renseigner pour cette date",
    "view_all_dates": "Voir le calendrier complet",
    "days_away": "jours restants",
    "today": "Aujourd'hui",
    "tomorrow": "Demain",
    "next_observance": "Prochaine célébration",
    "note": "Remarque",
    "festivals_disclaimer": "Les dates sont calculées à partir du cycle lunaire à l'heure normale de l'Inde et peuvent différer d'un jour par rapport à votre panchang local. Veuillez confirmer le muhurta exact avec Shivam Chatterjee avant de voyager.",
    "voices_eyebrow": "Voix des Fidèles",
    "voices_title": "Dans Leurs Mots",
    "translate_title": "Choisissez votre langue",
    "translate_sub": "Lisez TarapithTantrik dans la langue qui vous convient le mieux.",
    "translate_search": "Rechercher une langue",
    "translate_note": "Le bengali et le hindi sont révisés par notre équipe. Les autres langues sont traduites avec l'assistance d'une IA et constamment améliorées.",
    "no_results": "Aucune langue ne correspond à votre recherche.",
    "ai_translated": "Traduction assistée par ordinateur"
  }
};
